export default {
  v5: {
    my_video_shorts: '我的视频短片',
    see_more: '查看更多',
    no_shorts_found: '未找到短片',
    shorts: '短片',
    general_information: '一般信息',
    gamification: '游戏化',
    click_to_select_files: '点击选择文件',
    selected_files: '已选文件',
    uploaded: '已上传',
    failed: '失败',
    system_will_automatically_analyze_and_select_the_most_relevant:
      '系统将自动分析，并根据内容需求从您的组织库中选择最相关的文档。',
    select_from_library: ' 从库中选择',
    search_document: '搜索文档...',
    selected: '已选择',
    loading_documents: '文档加载中...',
    review_generated_content: '审核生成内容',
    confirm_and_replace_content: '确认并替换内容',
    the_generate_content_will_replace:
      '生成的内容将替换所选页面上的现有文本。如果不想应用这些更改，可以返回上一步。',
    pages_to_be_updated: '要更新的页面',
    generated_revisions: '生成的修订',
    lesson_preview: '课程预览',
    create_new_folder: '创建新文件夹',
    rename_item: '重命名项目',
    enter_folder_name: '输入文件夹名称：',
    enter_new_name: '输入新名称：',
    folder_name: '文件夹名称：',
    new_name: '新名称',
    move_items: '移动项目',
    copy_items: '复制项目',
    move_here: '移动到此处',
    copy_here: '复制到此处',
    select_destination_library_and_folder: '选择目标库和文件夹：',
    items_selected: '已选择项目',
    version: '版本',
    modified_by: '修改者',
    size: '大小',
    restore: '恢复',
    are_you_sure_you_want_to_restore_this_version: '您确定要恢复此版本吗？',
    this_will_replce_the_current_version_with_the_selected_one:
      '这将用所选版本替换当前版本。',
    restore_this_version: '恢复此版本',
    restore_not_available: '无法恢复',
    version_history: '版本历史：',
    by_making_items_public:
      '将项目公开后，所有人都能看到。在继续之前，请查看条款和条件。',
    the_selected_items_will_be_copied:
      '所选项目将复制到您的公共库，并对所有人可见。',
    the_selected_items_will_be_copied_to_org:
      '所选项目将复制到您的组织库，并对所有组织成员可见。',
    the_selected_items_will_be_copied_to_your_private:
      '所选项目将复制到您的私人库，仅对您可见。',
    loading_organization: '加载组织用户中...',
    click_download_to_view: '点击下载以查看',
    archive_file: '归档文件',
    no_preview_available: '无可用预览',
    audit_report: '审计报告',
    audit_type: '操作类型',
    i_agree_to_the_terms_and_conditions: '我同意条款和条件。',
    this_file_is_indexed_for_ai: '此文件已为 AI 编制索引。',
    file_is_not_indexed_for_ai: '文件未为 AI 编制索引。',
    no_users_found: '未找到用户',
    no_users_available: '无可用用户',
    add_people: '添加人员',
    people: '人员',
    access_type: '访问类型',
    no_group_found: '未找到组',
    add_group: '添加组',
    groups: '组',
    users_top: '用户',
    confirm_delete: '确认删除',
    do_you_want_remove: '您确定要移除',
    form_this_documents_permissions: '从此文档的权限中？',
    no_users_found_in_this_group: '在此组中未找到用户',
    add_selected_users: '添加已选用户',
    choose_users_from_the_list: '从列表中选择用户',
    selected_users: '已选用户',
    archived: '已归档',
    request_approval: '请求审批',
    document_in_review: '文档审核中',
    approve: '批准',
    reject: '拒绝',
    comment: '评论：',
    enter_your_commit: '输入您的评论...',
    confirm_cancel: '确认取消',
    upload_3d_zip: '上传 3D 压缩包',
    delete_items: '删除项目',
    video_upload_request: '视频上传请求',
    reject_video: '拒绝视频',
    enter_rejection_reason: '输入拒绝原因...',
    please_provide_a_reason_for_reejection_this_video:
      '请提供拒绝此视频的原因：',
    generate_trivia_with_ai: '用 AI 生成趣味问答',
    select_category: '选择类别：',
    number_of_question: '问题数量',
    generated_questions: '生成的问题',
    this_will_clear_all_generate_question: '这将清除所有生成的问题。继续吗？',
    sure_delete: '您确定要删除吗？',
    delete_this_question: '您确定要删除此问题吗？',
    loading_quiz: '加载测验中...',
    creteing_file: '正在创建文件',
    opening_desktop_app: '正在打开桌面应用...',
    this_folder_is_empty: '此文件夹为空',
    select_a_competition: '选择比赛...',
    activity_badges: '活动徽章',
    awarded_every_badges: '每 4、8、16、32、64、128、256、512 次登录颁发',
    learning_badges: '学习徽章',
    awarded_every_courses: '每 1、4、8、16、32、64、128 门完成的课程颁发',
    test_badges: '测试徽章',
    awarded_every_passes_tests:
      '每 2、4、8、16、32、64、128、256 次通过测试颁发',
    assignment_badges: '作业徽章',
    awarded_every_passed_assignments:
      '每 1、2、4、8、16、32、64、128 个已通过作业颁发',
    perfectionism_badges: '完美主义徽章',
    awarded_every_assignments_with_scrore:
      '每 1、2、4、8、16、32、64、128 个得分 90%+ 的测试或作业颁发',
    communication_badges: '沟通徽章',
    awarded_every_topics_or_comments:
      '每 2、4、8、16、32、64、128、256 个主题或评论颁发',
    certification_badges: '认证徽章',
    awarded_every_certificates: '每 1、2、4、8、16、32、64、128 个证书颁发',
    level_name: '等级名称',
    delete_competition: '删除比赛',
    this_week: '本周',
    this_year: '今年',
    make_organization: '设为组织',
    no_results_found: '未找到结果',
    no_items_available: '无可用项目',
    help_video: '帮助视频',
    select_a_video_from_the_list: '从列表中选择视频以开始学习'
  },
  v4: {
    drop_files: '拖放文件并选择上传位置。',
    duplicate_lessoon: '课程中已存在该课时',
    skill_rule_title: '请输入技能旅程标题',
    imageCreatorTitle: '图片生成器',
    isTranslated: '已翻译',
    translationCourseDesc: '课程翻译可能需要几分钟时间。感谢您的耐心等待！',
    translateCourseTip:
      '创建一个独立于原始课程的可编辑翻译副本，包括所有课程和页面。',
    translateModalBtn: '翻译',
    translationSuccess: '课程“<0/>”已成功翻译！',
    translatingCourse: '正在翻译课程...',
    translateModalTitle: '翻译课程',
    translateSelectLang: '选择语言',
    fileDeleteconfirm: '您确定要删除此文件吗？此操作无法撤销。',
    fileDeleteMessage: '文件已成功删除。',
    fileDeleteFailedMessage: '文件删除失败！',
    fileDelete: '删除此文件。',
    certificate_save_btn: '添加证书到 ',
    maze_path_info: '图表中没有可用路径！',
    file_size_mb: '文件大小必须小于 25MB！',
    reports: {
      products: '产品',
      users: '用户',
      ph_username: '按用户名搜索用户',
      ph_id: '按用户ID搜索用户',
      ph_email: '按邮箱搜索用户'
    },
    select_upload_section_id: '必须选择章节文件',
    tags_all: '全部',
    delete_file_confirm: '您确定要删除此文件吗？',
    delete_file_title: '删除文件',
    tooltip_publish: '在所选选项上发布课程',
    tooltip_save: '保存课程当前更新内容',
    tooltip_next: '前往下一个课程设置',
    tooltip_finish: '完成并保存当前更新',
    stories_modal: {
      title_upload: '上传故事',
      title_update: '更新故事',
      title_audio: '音频故事文件',
      btn_upload: '上传',
      btn_update: '更新',
      btn_close: '关闭',
      btn_cancel: '取消',
      lbl_cover: '故事封面图片',
      rule_cover: '请上传故事音频封面！',
      lbl_title: '故事音频标题',
      rule_title: '请输入故事音频标题！',
      lbl_description: '故事音频描述',
      rule_description: '请输入故事音频描述！',
      lbl_file: '上传故事音频文件',
      rule_file: '请上传故事音频文件！',
      rule_file_type: '请上传有效的故事音频文件！',
      lbl_select_file: '选择故事音频文件',
      msg_valid_file: '请选择有效的故事音频文件！',
      msg_success: '故事音频文件上传成功',
      msg_failed: '分配媒体数据失败！',
      msg_error: '文件上传错误！'
    },
    audio_modal: {
      title_upload: '上传',
      title_update: '更新',
      title_audio: '音频文件',
      btn_upload: '上传',
      btn_update: '更新',
      btn_close: '关闭',
      btn_cancel: '取消',
      lbl_cover: '音频封面',
      rule_cover: '请上传音频封面！',
      lbl_title: '音频标题',
      rule_title: '请输入音频标题！',
      lbl_description: '音频描述',
      rule_description: '请输入音频描述！',
      lbl_file: '上传音频文件',
      rule_file: '请上传音频文件！',
      rule_file_type: '请上传有效的音频文件！',
      lbl_select_file: '选择音频文件',
      msg_valid_file: '请选择有效的音频文件！',
      msg_success: '音频文件上传成功',
      msg_failed: '分配媒体数据失败！',
      msg_error: '文件上传错误！'
    },
    info_episode: '该剧集的封面图片。',
    btn_delete_episode: '删除该播客剧集。',
    btn_edit_marketplace: '编辑市场详情。',
    btn_save_marketplace: '保存当前更改。',
    btn_ai_podcast: '创建AI播客剧集。',
    btn_upload_podcast: '上传您自己的播客音频剧集。',
    attach_file: '上传文件以与观众分享更多内容',
    fileDownload: '下载此文件。',
    singleEpishode: '剧集',
    podcast_music: '播客、音乐和故事',
    publishHeader: '发布播客、音乐和故事',
    editHeader: '编辑播客、音乐和故事',
    createHeader: '创建播客、音乐和故事',
    marketplaceHeader: '播客、音乐和故事市场详情',
    message_marketplace: '请填写市场表单！',
    create_podcast_live: '实时播客和音乐',
    create_podcast_custom: '自定义播客和音乐',
    create_podcast_stories: '故事',
    ai_Assisted_podcast_reation: 'AI辅助播客和音乐',
    publishTitle: '将播客、音乐和故事公开发布。',
    customButton: '创建自定义',
    customTitle: '保存对播客所做的更改。',
    updateButton: '更新',
    createButton: '创建',
    createNewButton: '创建新的',
    updateTitle: '更新当前播客、音乐和故事的详情。',
    createTitle: '创建新的播客、音乐和故事',
    createNewTitle: '将在当前播客、音乐和故事上基于新输入创建新的内容。',
    podcastTitle: '剧集列表',
    podcastStoryTitle: '故事剧集列表',
    podcastToolTipTitle: '播客剧集列表',
    uploadAudio: '上传',
    aiAudio: 'AI音频',
    emptyPodcast: '尚未录制任何播客、音乐或故事。',
    emptyStoriesPodcast: '尚未添加任何故事。',
    emptyCreatePodcast: '请先创建播客以添加音频。',
    playPodcast: '播放所选的播客、音乐和故事。',
    pausePodcast: '暂停所选的播客、音乐和故事。',
    selectPodcast: '选择该播客、音乐和故事。',
    downloadPodcast: '下载此音频。',
    uploadAudioFile: '上传新的音频并替换当前音频。',
    deleteConfirm: '您确定要删除此音频吗？',
    roomName: '播客名称',
    addGuestTitle: '添加嘉宾讲者',
    showTime: '演出时间',
    startTime: '开始时间',
    endTime: '结束时间',
    erorMsgImg: '请选择有效的图片。',
    failedMsgImg: '图片加载失败，请重试！',
    failedMsgUpload: '封面上传失败！',
    btnCoverUpload: '上传封面',
    is_private: '私密',
    to_attach: '附加文件',
    file_attached: '附加文件',
    main_event: '主要活动',
    event: '活动',
    upload_pdf: '上传PDF文件',
    portrait: '竖屏',
    landscape: '横屏',
    import_from_library: '从媒体库导入文本',
    question_answer_ai: '问答 AI',
    take_maze: '进入 MetaMaze',
    training: '培训',
    select_transcribe_locale: '选择转录语言',
    transcribe_limit: '请输入转录时间（分钟）',
    not_complete: '市场信息未完成',
    complete: '市场信息已完成',
    not_admin: '需要管理员权限才能发布到市场',
    no_course: '请输入标题并选择图片以启用市场功能',
    scorm_not_complete: '请输入标题并选择图片以上传 SCORM 文件',
    not_found_maze: '未找到 MetaMaze',
    email_require: '需要填写电子邮件',
    poll_required: '需要问卷数据',
    alert: '提醒！',
    warning: '警告！',
    ok: '确定',
    cancel: '取消',
    done: '完成',
    insert: '插入',
    private: '私有',
    public: '公开',
    no_connection: '网络连接已断开',
    switch: '切换',
    share_screen: '共享屏幕',
    stop_share_screen: '停止共享屏幕',
    share_screen_with_camera: '同时共享屏幕和摄像头',
    stop_share_screen_with_camera: '停止共享屏幕和摄像头',
    camera_on: '打开摄像头',
    camera_off: '关闭摄像头',
    mic_on: '取消静音',
    mic_off: '静音',
    fullscreen: '全屏',
    live_now: '正在直播',
    schedule_on: '安排于',
    organisations: '组织',
    org_groups: '组织分组',
    specific_user: '指定用户',
    gif: 'GIF',
    unavailable: '不可用',
    yes: '是',
    no: '否',
    event_duration_message: '最长 300 分钟（5 小时）',
    send_email: '发送电子邮件通知',
    admin_only: '仅限管理员',
    join: '加入',
    leave: '离开',
    share: '分享',
    share_text: '请输入您希望分享此文件的电子邮件地址。',
    share_text_title: '分享 PDF',
    share_text_title_txt: '分享文本',
    select_users: '选择用户',
    delete: '删除',
    attachment_event: '活动附件：',
    transcribe_limit: '转录时间（分钟）',
    monthly_transcribe: '每月转录限制：',
    enable_ai: '启用 AI：',
    enable_maze: '启用 MetaMaze：',
    media_service: '媒体服务',
    allow_others: '允许他人编辑',
    join_breakout_room: '加入分组讨论室',
    bio: '简介',
    linkedin: 'LinkedIn',
    select_org_report: '请选择一个组织生成报告。',
    org_image_not_found: '未找到图片',
    insert_text: '插入文本',
    insert_question_answer: '问答 AI',
    modal_title2: '文本库',
    my_text_library: '我的文本库',
    ai: '人工智能',
    public_text_library: '公共文本库',
    organization_text_library: '组织文本库',
    no_transcribed_text: '未找到转录文本',
    public_text_not_found: '未找到公共转录文本',
    org_text_not_found: '未找到组织转录文本',
    org_video_not_found: '未找到视频',
    canva: '使用 Canva 设计',
    canva_open: '点击此处打开 Canva 编辑器。',
    pdf: 'PDF',
    txt: '文本',
    human: '高级',
    shared_file: '您的文件已成功分享。',
    error_shared_file: '文件分享出错，请重试。',
    publish: '发布',
    maze_scenes: 'MetaMaze 场景',
    pexel_images: 'Pexel 图片',
    group: '群组',
    group_name: '群组名称',
    select_group: '选择群组',
    search_maze: '搜索 MetaMaze',
    hosts: '主持人',
    avg_score: '平均得分（百分比）',
    maze_report: 'Maze 报告',
    maze_view: 'Maze 视图',
    title_maze: 'MetaMaze',
    author: '作者',
    match: '路径匹配',
    preview_mazeTitle: '标题：',
    other: '其他',
    total: '总计',
    report_course: '课程',
    report_courses: '课程',
    report_event: '活动',
    report_events: '活动',
    report_maze: '迷宫',
    report_personalize_learning: '个性化学习',
    report_live_assessment: '实时评估',
    report_live_assessments: '实时评估',
    report_skill_journey: '技能旅程',
    skill_journey: '技能旅程',
    skill_journeys: '技能旅程',
    date: '日期：',
    search_people: '搜索人员',
    passed: '通过',
    failed: '未通过',
    item: '项目',
    type: '类型',
    minimum_pass_score: '最低通过分数',
    resources_count: '资源数量',
    back: '返回',
    resources: '资源',
    time_spent: '花费时间（分钟）',
    detail: '详情',
    watched_time_mins: '观看时间（分钟）',
    personalize_learning: '个性化学习',
    result: '结果',
    assessment_title: '标题',
    marketPlace_graph: '市场图表',
    attachments: '附加文件',
    new_scorm_course: '上传新的 SCORM 课程',
    upload_scorm_course: '上传 SCORM 课程',
    new_maze: '创建新的 MetaMaze',
    new_skill_journey: '创建技能旅程',
    tags_scorm: 'SCORM',
    tags_skillJourney: '技能旅程',
    new_discussion_room: '创建新的播客',
    title: '今天您想做什么？',
    build_course: '创建我的课程',
    live_broadcast: '直播',
    invite_users: '邀请用户加入我的组织',
    build_voice_over: '制作我的配音',
    view_reports: '查看报告',
    upload_media: '上传我的媒体或作品并分享',
    main_menu: '主菜单',
    get_started: '开始使用',
    search_group: '搜索组织群组',
    ai_course: 'AI 课程',
    search_user: '搜索公司名称',
    no_maze: '当前暂无 MetaMaze。',
    conference_event_title: '会议活动',
    conference_event_subTitle: '已结束的会议活动',
    conference_event: '当前暂无会议活动。',
    no_skill: '当前暂无技能旅程。',
    no_podcast: '当前暂无播客。',
    maze_channel: 'MetaMaze',
    past_live_assessment: '历史直播测评',
    no_live_assessment: '当前暂无直播测评。',
    enrolled_courses: '课程',
    my_video_channel: '我的视频频道',
    enrolled_liveEvents: '直播活动',
    sharebot: 'Sharebot',
    selected_language: '已选择语言',
    shareSphere_game: 'ShareSphere 游戏',
    maze: 'MetaMaze',
    skill: '技能旅程',
    channel: '频道',
    order: '订单',
    is_record: '录制',
    no_maze_found: '未找到 MetaMaze。',
    maze_self_limit_reached: '已达到 MetaMaze 自评次数上限。',
    metamaze_two_times: '您已参加该 MetaMaze 两次。',
    metamaze_two_times_no_result:
      '您已参加该 MetaMaze 两次。超过两次完成该自评将不会记录结果。',
    scorm_zip: 'SCORM ZIP 文件',
    pass_score: '及格分数',
    organization: '请选择一个组织',
    pass_score_mark: '请输入 1 到 100 之间的分数',
    maze_cloning_success: 'MetaMaze "<0/>" 克隆成功！',
    create_certificate: '创建证书',
    create_badge: '创建徽章',
    certificate_added: '证书已添加。',
    badge_added: '徽章已添加。',
    certificate_warning: '证书/徽章发布后将无法编辑！',
    created_course_plan: '编辑并发布您创建的课程，并安排直播活动',
    market_place_space: '市场空间',
    select_course_language: '选择语言（可选）',
    select_language: '选择语言',
    file_upload: '文件上传',
    text: '在此输入文本…',
    attempts_count: '用户可重复尝试的次数',
    no_of_people_placeholder: '人数',
    back_to_maze: '返回 MetaMaze 场景',
    edit_maze: '编辑 Maze',
    wait: '请稍候…',
    retry: '重试',
    publish_scorm_course: '发布您的 SCORM 课程',
    publish_maze: '发布您的 MetaMaze',
    import: '导入元素',
    answer_correct: '选择正确答案',
    author_name: `请输入作者姓名`,
    select_category: '请选择一个类别',
    course_outline: '请输入课程大纲',
    course_obj: '请输入课程目标',
    course_description: '请输入课程描述',
    maze_outline: '请输入迷宫大纲',
    maze_obj: '请输入迷宫目标',
    maze_description: '请输入迷宫描述',
    lessons: '请输入课程节数',
    user_email_require: `用户邮箱是必填项`,
    team_size: `团队人数是必填项`,
    enter_price: '请输入价格（5或以上）',
    input_title_maze: '请输入迷宫标题',
    trainer_bio: '请输入讲师简介',
    trainer_linkedin: '请输入讲师的 LinkedIn 链接',
    error_video: '请输入视频数量',
    input_video_link: '请输入视频链接',
    number_of_video: '视频数量',
    number_of_lessions: '课程节数',
    no_of_people_in_conference: '会议中有多少人？',
    transcribe_settings: '转录设置',
    transcribe: '转录',
    cloning_maze: '正在克隆 MetaMaze...',
    id_number: '身份证号',
    timezone: '时区',
    edit_maze: '编辑',
    delete_maze: '删除',
    view_maze: '查看',
    create_metamaze: '创建 MetaMaze',
    metamaze_scenario: 'MetaMaze 场景',
    publish_metamaze: '发布设置',
    search_result: '搜索结果：',
    search_for: '搜索内容',
    search_no_result: '- 暂无搜索结果！',
    channel_no_available: '没有可用的频道！',
    this_card: '这是一个卡片',
    course_no_available: '暂无可用课程！',
    exit_fullscreen: '退出全屏',
    bg_image: '背景图片',
    introduction: '介绍',
    summary: '总结',
    generate_introduction: '生成介绍',
    generate_summary: '生成总结',
    bullet_points: '要点',
    title_simulation: '请输入模拟名称',
    view_generated_images: '查看生成的图片',
    image_transparency: '图片透明度',
    template_bg_color: '模板背景颜色',
    select_template_layout: '选择模板布局',
    reload_template: '（重新加载模板）',
    are_you_sure_want_close: '您确定要关闭吗？',
    all_your_changes_will_be_lost: '您所有的更改都将丢失。',
    please_checked_before_generated_video:
      '请确认在生成视频前所有条件都已勾选。',
    voice_must_be_selected: '必须选择一个语音',
    avatar_must_be_selected: '必须选择一个头像图片。',
    maximum_five_slides_try_again:
      '从文件中提取图片时出错。请确保您的文件中最多包含5张幻灯片，且每张幻灯片都有备注。请重试！',
    back_to_upload: '返回上传页面',
    uploading_file_to_server: '正在将文件上传至服务器',
    extracting_images_from_your_file: '正在从文件中提取图片',
    upload_your_ppt_or_drag: '上传您的演示文稿文件（.PPTX）或将其拖动到此处。',
    maximum_five_slides_error:
      '请确保您的PowerPoint文件最多包含5张幻灯片，并且每张幻灯片中都有备注，否则将导致错误。',
    number_of_questions_generated: '要生成的问题数量',
    quiz_page_this_cannot_be_done:
      '您确定要将此测验添加到该页面吗？此操作无法撤销。',
    confirm_selection: '确认选择',
    select_quiz_page: '选择测验页面',
    lesson_do_you_want_add_this_quiz: '您希望将此测验添加到课程的哪个部分？',
    beginning_of_lesson: '课程开始时',
    end_of_lesson: '课程结束时',
    currently_active_page: '当前活动页面',
    finish: '完成',
    upload_selection_file: '上传部分文件',
    general_quiz: '通用测验',
    manage_sequence: '管理顺序',
    save_sequence: '保存顺序',
    new: '新的',
    in_progress: '进行中',
    recommended_course: '推荐课程',
    up_coming: '即将上线',
    past_live: '过去直播',
    input_your_channel_name: '请输入您的频道名称！',
    organization_place: '组织市场',
    marketplace_report: '市场报告',
    story_writing: '故事写作',
    Ai_quiz: 'AI 测验',
    generate_quiz: '生成测验',
    create_story: '创建故事',
    change_layout_page: '您即将更改此页面的布局。',
    change_layout_message:
      '请注意，仅文本、图片、背景和徽标将被保留。页面中的其他元素都将被移除。',
    reviews: '评价',
    tab_attachments: '附件',
    zoom_in: '放大',
    zoom_out: '缩小',
    zoom_reset: '重置缩放',
    no_attachment: '暂无附件。',
    select_upload_simulation: '请选择/上传模拟内容。',
    quiz_updated_successfully: '测验更新成功！',
    quizes: '测验',
    trivia: '知识问答',
    closing: '正在关闭...',
    products: '产品',
    ask_questions: '在此提问...',
    course_information: '课程信息',
    course_assistance: '课程创建者协助',
    go_back: '返回',
    ai_generate_content_progress: '正在生成内容进度',
    view_generate_content: '查看已生成内容',
    generate_error: '生成出错！',
    confirm_creating_course: '是否确认使用此内容创建课程？',
    generate_content_automatically:
      '这将自动将所有生成的内容添加为课程中的课程和页面。',
    quiz_created_successfully: '测验创建成功！',
    create_quiz: '创建测验',
    quiz_setting: '测验设置',
    please_fill_quiz_setting: '* 请填写测验设置中的所有字段',
    question_list: '问题列表',
    add_quiz_to_page: '将测验添加到页面',
    form_create_question: '创建问题表单',
    user_information_updated: '用户信息已更新！',
    your_stripe_activete_to_continue:
      '您的 Stripe 账户未激活。请连接或激活以继续。',
    connect_tripe: '连接 Stripe',
    certificate_sent_sucessfully: '证书已成功发送到您的邮箱。',
    error_try_again: '错误，请重试！',
    error_delete_channel: '删除频道时出错。',
    error_update_sub: '更新订阅时出错。',
    end_time_cannot_start: '结束时间不能早于开始时间。',
    start_date_time_interval: '开始日期和时间间隔为必填项！',
    podcast_updated_successful: '播客更新成功。',
    podcast_created_successful: '播客创建成功。',
    podcast_published_successful: '播客发布成功。',
    podcast_cover_updated: '播客封面已更新。',
    new_podcast_details: '将基于当前播客和新输入创建一个新播客。',
    current_update_podcast: '更新当前播客、音乐和故事详情。',
    create_new_podcast: '创建新播客',
    publish_podcast_public_view: '发布播客以供公开查看。',
    only_allowed_twenty_five_email: '最多允许 25 个电子邮件地址。',
    only_allowed_five_email: '最多允许 5 个电子邮件地址。',
    cover_is_required: '封面是必填项。',
    topic_is_required: '主题是必填项。',
    delete_schedule: '删除日程',
    make_as_coaching: '标记为辅导可用时间',
    manage_category: '管理分类',
    threshold: '阈值',
    threshold_popup: '百分比形式的阈值，当超过此值时将激活对应分类的推荐。',
    list_of_catagory: '分类列表',
    category_name: '分类名称',
    category_threshold: '分类阈值',
    play_game: '开始游戏',
    switching_organization: '正在切换组织...',
    coaching_session: '辅导会议',
    required_channel_id: '频道 ID 是必填项！',
    error_occured_try_again: '发生错误，请重试！',
    please_complete_marketplace_form: '请完成市场表单！',
    upload_file_corrupt: '上传的文件已损坏。',
    course_not_published: '课程尚未发布！',
    error_request: '请求错误，请重试！',
    skill_request: '请填写所有缺失字段！',
    error_occured: '发生错误，请重试！',
    show_time: '显示时间',
    start_time: '开始时间',
    end_time: '结束时间',
    room_name: '播客名称',
    add_guest_speaker: '添加嘉宾讲者',
    cover_picture: '封面图片',
    guest_speaker: '嘉宾讲者',
    see_more: '查看更多',
    see_less: '收起',
    background: '背景',
    icon: '图标',
    icon_size: '图标大小',
    icon_color: '图标颜色',
    only_text: '文本',
    change_bg: '更改背景颜色',
    bg_color: '背景颜色',
    font_size: '字体大小',
    normal: '正常',
    change_color: '更改文本颜色',
    slant_text: '斜体文字',
    text_radius: '文字圆角',
    vertical_align: '垂直对齐',
    horizontal_align: '水平对齐',
    change_icon_color: '更改图标颜色',
    upload_icon: '上传图标',
    upload_signature: '上传签名',
    add_another_sign: '添加另一个签名',
    name_badges: '徽章名称',
    should_less_150: '应少于 150 个字符',
    your_badge: '您的徽章',
    do_you_want_delete_badge: '确定要删除此徽章吗？',
    do_you_want_delete_cert: '确定要删除此证书吗？',
    upload_logo: '上传标志',
    name_of_cert: '证书名称',
    upload_cert: '更新证书',
    your_cert: '您的证书',
    translate_to: '翻译为',
    select_file_attach: '选择要附加的文件',
    certificate: '证书',
    badge: '徽章',
    publish_options: '发布选项',
    publish_skills_journey: '发布技能旅程',
    videos: '视频',
    generate_ai_video:
      '视频生成过程可能需要一些时间，完成后我们将通过邮件通知您。',
    trainer_information: '讲师信息',
    promotional_video_link: '宣传视频链接',
    please_select: '请选择',
    image_name: '图片名称：',
    image_size: '图片大小：',
    charecters_fifteen_less: '15 个字符或更少',
    leadership: '领导力',
    text_arc: '文字弧形',
    vertical: '垂直',
    horizontal: '水平',
    badge_history: '徽章历史',
    templates: '模板',
    sign: '签名',
    logo: '标志',
    certificate_history: '证书历史',
    please_wait: '请稍候...',
    information: '信息',
    support_five_thousand_live_event: '支持最多 5000 名参与者的活动',
    support_ten_live_event: '支持最多 10 名视频参与者',
    we_will_back_participant: '我们将带来支持大量参与者的活动。',
    course_objectives: '课程目标',
    course_outlines: '课程大纲',
    price_dollor: '价格（美元）',
    not_completed: '未完成',
    enable_marketplace: '启用市场功能',
    enable_course_ai: '启用 AI 课程创建',
    enable_report_to_admin: '启用管理员报告显示',
    enable_white_label: '启用白标模式',
    enable_eleven_labs_for_maze_play: '启用 Elevenlabs 用于迷宫玩法',
    enable_eleven_labs_for_maze_play_cloned: '启用 Elevenlabs 克隆语音',
    simulation_quiz: '模拟测验',
    bg_color_setting: '背景颜色设置',
    color_preview: '颜色预览',
    choose_new_color: '选择新颜色',
    remove_color: '移除颜色',
    apply_color: '应用颜色',
    elemeent_in_a_sceenario_page:
      '您无法在情景页面添加其他元素。请尝试其他页面或先从页面中移除情景元素。',
    no_data_found: '未找到数据。',
    references: '参考资料',
    open_file: '打开文件',
    showing_result: '显示结果：',
    fiften_day_free_trail: '15 天免费试用',
    your_browser_does_not_support: '您的浏览器不支持该音频元素。',
    podcast_desc: '播客描述',
    input_podcast_desc: '请输入播客描述',
    podcast_obj: '播客目标',
    input_podcast_obj: '请输入播客目标',
    podcast_outline: '播客大纲',
    input_podcast_outline: '请输入播客大纲',
    add_file: '添加文件',
    generate_podcast_audio: '生成播客音频',
    generate_uploaded_file_input_parameter:
      '根据上传的文件和输入参数生成内容。',
    go_backe_generation_state: '返回内容生成状态',
    create_ai_powered_podcast: '使用生成的音频创建 AI 驱动的播客剧集。',
    generate_voice_for_all_podcast: '请为所有播客剧集生成语音',
    create_podcast_episode: '创建播客剧集',
    voice_name: '语音名称',
    input_custom_name: '请输入自定义名称！',
    enter_custom_name: '输入自定义语音名称',
    upload_complete: '上传完成',
    uploading_in_progress: '上传中...',
    podcast_stream_content: '播客流媒体内容',
    upload_podcast_cover: '请上传播客封面！',
    enter_podcast_name: '请输入播客名称！',
    podcast_topic: '播客主题',
    enter_podcast_topic: '请输入播客主题！',
    enter_podcast_desc: '请输入播客描述！',
    number_of_speaker: '讲话人数',
    select_the_number_of_speaker: '请选择讲话人数！',
    number_of_episode: '剧集数量',
    input_number_of_episode: '请输入剧集数量！',
    podcast_length: '播客时长',
    select_the_podcast_length: '请选择播客时长！',
    short_podcast: '短（5-10 分钟）',
    medium_podcast: '中（15-18 分钟）',
    long_podcast: '长（18 分钟以上）',
    name_of_host: '主持人姓名',
    enter_host_name: '请输入主持人姓名！',
    guest_name: '嘉宾姓名',
    enter_guest_name: '请输入嘉宾姓名！',
    choose_speaker_tone: '选择讲话语气',
    enter_speaker_tone: '请选择播客语气！',
    informal: '非正式',
    formal: '正式',
    serious: '严肃',
    light_humor: '轻松幽默',
    casual: '随意',
    select_content_source: '选择内容来源',
    from_internet: '来自互联网',
    upload_pdf_internet: '上传 PDF 或内部文档',
    note: '注意：',
    podcast_content_will_be_automatically_generated:
      '播客内容将基于可信的互联网来源自动生成。',
    upload_or_select_file: '请上传或选择文件！',
    podcast_eposode_title: '播客剧集标题',
    enter_podcast_title: '请输入剧集标题！',
    podcast_episode_des: '播客剧集描述',
    enter_podcast_episode_des: '请输入剧集描述！',
    voice: '语音',
    music: '音乐',
    select_music: '选择音乐',
    play_the_music: '播放音乐',
    stop_the_music: '停止音乐',
    context: '上下文',
    generate_audio_content_selected_voice: '将根据内容和所选语音生成音频。',
    required_field_before_submitting: '提交前请填写所有必填项。',
    regenerate_voice: '重新生成语音',
    generate_voice: '生成语音',
    your_browser_does_not_suppot: '您的浏览器不支持音频元素。',
    are_sure_leave_podcast: '确定要离开播客吗？',
    broadcast_ongoing: '当前正在直播，您确定要离开此页面吗？',
    brodcaster_unavailable: '当前主播不可用。',
    setting_calender_for_booking: '正在设置预订日历',
    add_calender: '添加日历',
    waiting_join_host: '正在等待主持人加入...',
    no_reviews_found: '未找到评论。',
    rated_already: '您已为此直播活动评分。',
    downlink_png: '下载 PNG',
    downlink_jpg: '下载 JPG',
    donwload_file_format: '请选择您要下载的文件格式。',
    crashed_event:
      '此活动已发生故障，请创建一个新活动。对此造成的不便我们深感抱歉。',
    prompt: '提示词：',
    generated_image: '🚀 正在生成图像...请稍候。',
    download_add: '全部下载',
    setting_generator: '设置生成器',
    enter_image_prompt: '请输入图像提示词',
    image_prompt: '输入您的图像提示词',
    negative_prompt: '负面提示词',
    negative_image_prompt: '输入您的负面图像提示词',
    number_output: '输出数量',
    enter_number_output: '请输入输出数量',
    image_style: '请选择图像风格',
    output_format: '输出格式',
    seeds: '种子',
    enter_seeds: '请输入种子数量',
    performance_mode: '性能模式',
    quality: '质量',
    speed: '速度',
    balanced: '平衡',
    guidance_scale: '引导比例',
    enter_guidance: '请输入引导比例',
    select_image: '请选择图像。',
    image_prmt: '图像提示词',
    generate_image_list_empty: '生成的图像列表为空。',
    knowledge_center_tooltrip_des:
      '获取简洁、符合上下文的精确回答，涵盖常见知识问题。回答由经过训练的 AI 模型根据互联网上的信息生成。',
    contexts: '上下文',
    ai_processing_video_sharebot:
      'AI 处理视频大约需要 24 小时后才会在 Sharebot 中可用。',
    remove_sharebot_video: '若要删除 Sharebot 的视频引用，请删除视频及其脚本。',
    remove_sharebot_video_audio:
      '删除脚本将移除 Sharebot 的视频/音频引用，但媒体库/频道中仍会显示。',
    monthly_live_stream: '要更改您的每月直播限制，请联系我们',
    monthly_transcribe_limit: '要更改您的每月转录限制，请联系我们',
    must_be_one_to_three_hundred: '必须在 1 到 300 分钟之间。',
    all_field_required: '所有字段均为必填项。',
    duration_minute: '时长（最多 300 分钟）',
    gender: '性别',
    select_gender: '选择性别',
    accent: '口音',
    select_accent: '选择口音',
    create_voice: '创建语音',
    enter_voice_name: '输入语音名称',
    select_voice_gender: '请选择语音性别',
    upload_voice: '上传你的语音',
    upload_voice_mp_three: '上传你的语音文件（.mp3）',
    cloned_voice: '克隆语音',
    voice_type: '语音类型',
    select_voice_type: '选择语音类型',
    sharelook_stand: '标准',
    sharelook_premium: '高级',
    sharelook_custum_voice: '自定义（语音克隆）',
    create_auto_flow: '创建自动流程',
    how_many_layers: '有多少层',
    verify_selection: '确认选择',
    uploaded_successful: '上传成功',
    upload_failed: '上传失败',
    upload_only_five_mb: '上传内容（PDF文件，最多5个）',
    docs_from_org_library: '使用组织文档库中的文档',
    failed_maze_generate: '迷宫生成失败。请重试。',
    generate_metamaze: '正在生成MetaMaze...',
    metamaze_being_generated:
      '你的MetaMaze正在生成中。生成完成后我们将通过邮件通知你。',
    metamaze_generate_successfully: 'MetaMaze生成成功！',
    metamaze_with_proceed: '你现在可以继续使用MetaMaze了。',
    ai_metamaze_generate: 'AI生成MetaMaze',
    what_kind_maze_create: '你想创建什么类型的迷宫？',
    manual_metamaze_creation: '手动创建MetaMaze',
    manually_maze_customizing_scnario: '通过自定义场景和选项树手动创建迷宫',
    maze_ai_generated: '由AI自动生成的迷宫',
    unmark_deadend: '取消标记死路',
    mark_deadend: '标记为死路',
    select_multiple_image_for_scenario: '你可以为场景选择多张图片。',
    select_your_image: '你选择的图片',
    click_to_preview: '点击预览',
    are_you_sure_delete_image: '你确定要删除这张图片吗？',
    select_image_from_library: '从媒体库中选择图片',
    uploading_video: '正在上传视频...',
    tree_node_type: '树节点类型',
    correct_option_scenario: '正确选项或场景',
    incorrect_option: '错误选项',
    option_scenario_without_text: '无文本的选项或场景',
    dead_end: '死路（红色边框）',
    correct_path: '正确路径',
    incorrect_path_not_selected_correct_option_path:
      '错误路径 / 未选择正确选项的路径',
    double_click_on_tree_node: '双击树节点，文本编辑器将自动滚动至该节点内容。',
    add_scenario: '添加场景',
    add_option: '添加选项',
    an_error_occured: '发生错误：',
    download_summary: '下载摘要',
    step_wise_analysis: '逐步分析',
    step: '步骤',
    upload_csv_file: '上传CSV文件',
    download_template_to_import: '下载示例模板以导入',
    please_input_email: '请输入邮箱地址。',
    email_at_least_three_characters: '邮箱地址至少包含3个字符。',
    email_cannot_be_empty: '邮箱不能为空。',
    input_email_in_new_line: '请逐行输入邮箱（每行一个）',
    role: '角色',
    select_role: '请选择角色',
    select_group: '请选择分组',
    identification_number: '身份证号（可选）',
    add_identification_number: '请输入身份证号',
    pie_chart_of_all_categories: '基于Sharelook使用的所有类别的饼图。',
    total_sharesphere_question_answered_by_users:
      '当前组织中用户在所有ShareSphere问题上的总答题量，以及各类别的正确与错误结果。',
    voice_style_over_the_text:
      '你可以对所输入的文本应用多种语音风格。示例：Lorem Ipsum是印刷和排版行业的虚拟文本...',
    input_your_question: '请输入你的问题！',
    make_me_sales_manager: '例如：怎样才能成为销售经理？',
    enter_the_number_relevant_document: '输入相关文档数量',
    please_wait_loading_result: '请稍候，正在加载结果...',
    no_result_found: '未找到结果，请尝试其他问题',
    browser_doesnot_support_iframes: '你的浏览器不支持iframe',
    total_duration: '总时长',
    number_of_messages: '消息数量',
    search_result: '搜索结果',
    count_result: '（共1244个结果）',
    your_other_interests: '你的其他兴趣',
    your_total_score: '你的总得分',
    add_a_question: '+添加问题',
    travia_question_empty: 'Travia问题列表为空。',
    video_generation_is_on_queue: '视频生成排队中！',
    checking_video_status: '正在检查视频状态...',
    total_quizzes: '测验总数',
    number_of_votes: '投票数量',
    total_events: '活动总数',
    number_of_rates: '评分数量',
    number_of_likes: '点赞数量',
    all_courses: '所有课程',
    total_questions: '总问题数',
    no_skill_journey: '暂无可用技能路径！',
    search_no_results: '- 未找到搜索结果！',
    no_image_generated: '未生成图片！',
    all_topic_in_this_lesson: '该课程中的所有主题都将被删除，此操作不可撤销。',
    content_has_been_generated: '已为此主题生成内容。',
    update_course_template: '更新课程模板',
    add_course_template: '添加课程模板',
    create_course_now: '立即创建课程',
    preview_course: '预览课程',
    layout: '布局',
    import_from_youtube: '从YouTube导入',
    my_media_library: '我的媒体库',
    bg_added: '已添加背景',
    add_bg: '添加背景',
    booked_schedule: '已预定的日程',
    add_schedule: '添加日程',
    are_you_delete_schedule: '你确定要删除此日程吗？',
    add_task: '添加任务',
    update_calender: '更新日历',
    manage_cookies: '管理 Cookies',
    cookie_banner_text:
      '我们使用 Cookies 来提升您的浏览体验，分析网站流量，并个性化内容。您的隐私对我们非常重要。',
    accept_all_cookies: '接受所有 Cookies',
    reject_all: '全部拒绝',
    customize: '自定义',
    cookie_preferences_title: 'Cookies 偏好与隐私设置',
    privacy_subtitle:
      '您的隐私对我们很重要。请选择您愿意接受的 Cookies。您可以随时更改这些设置。',
    save_choices: '保存我的选择',
    strictly_necessary: '严格必要',
    strictly_necessary_desc:
      '这些 Cookies 对网站正常运行至关重要。它们启用基本功能，如页面导航、表单提交和访问安全区域。没有它们，网站无法正常运行。',
    analytics_performance: '分析与性能',
    analytics_performance_desc:
      '这些 Cookies 帮助我们通过匿名收集和报告信息来了解访客如何使用网站，从而改善网站性能和用户体验。',
    advertising_marketing: '广告与营销',
    advertising_marketing_desc:
      '这些 Cookies 用于使广告信息更符合您的兴趣。它们可以防止同一广告重复出现，并确保广告正确展示给广告主。',
    tracking_social: '追踪与社交媒体',
    tracking_social_desc:
      '这些 Cookies 支持增强功能和个性化体验，例如社交媒体功能和个性化内容。它们可能由我们或第三方提供。',
    functional: '功能性',
    functional_desc:
      '这些 Cookies 提供增强功能，如聊天支持、实时帮助和其他互动功能，提升您在网站上的体验。',
    your_rights: '您的权利：',
    rights_description: '您可以随时撤回同意、访问数据或请求删除数据。',
    withdraw_consent: '撤回全部同意',

    how_many_options: '选项数量',
    add_content: '添加内容',
    downloads_center: '下载中心',
    sharelook_help_center: 'Sharelook 帮助中心',
    channel_outline: '频道大纲',
    channel_objectives: '频道目标',
    no_sop_available: '暂无 SOP 列表。',
    generate_world_summary: '生成场景',
    world_scenario: '现实场景',
    drag_icon_hint: '提示：将图标拖动到画布上以定位',
    drag_text_hint: '提示：将文字拖动到画布上以定位',
    edit_badge: '编辑徽章',
    create_new_badge: '新建徽章',
    select_video_preview: '选择视频进行预览',
    certificate_title_required: '证书标题为必填项',
    discard_changes: '放弃更改',
    edit_certificate: '编辑证书',
    add_another_logo: '添加另一个徽标',
    optional: '可选',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: '创建新任务',
    quest_filter_title: '任务',
    sharelook_assistance: 'Sharelook 辅导',
    upload_scorm_zip: '上传 SCORM ZIP',
    only_letters_numbers_space_dot_allowed: '只允许字母、数字、空格和点！',
    video_playing: '播放中',
    course_price_message: `*课程只会发布给组织内用户，无法在市场上转售。`,
    lesson_must_be_positive: '课程数必须大于 1',
    btn_proceed: '继续',
    rule_select_music: '请选择音乐',
    course_info: '课程信息',
    content_selection: '内容选择',
    course_content_source: '课程内容来源',
    choose_how_to_source: '选择如何获取本课程的内容：',
    automatic_selection: '自动选择',
    system_will_automatically_select_relavant_documents:
      '系统将自动从您的库中选择相关文档',
    manual_selection: '手动选择',
    choose_specific_documents_from_your_library: '从您的库中选择特定文档',
    upload_files: '上传文件',
    upload_new_documents:
      '上传新文档（PDF、DOC、DOCX、PPT、PPTX、TXT）- 最多 5 个文件',
    file: '文件',
    ready_to_upload: '准备上传',
    clear_all: '全部清除',
    confirm_course_wide_premiew: '确认全课程预览',
    generate_course_preview: '生成课程预览',
    instructions_across_the_course_to_generate:
      '我们将根据您的指示对整个课程应用生成预览。在选择保存或放弃更改前，请先检查所有内容。',
    instruction_to_preview_course_wide: '全课程预览指示：',
    edit_content: '编辑内容',
    manage_course_template: '管理课程模板',
    undo: '撤销',
    apply_changes: '应用更改',
    characters: '字符',
    apply_all: '应用全部',
    apply_to_all: '应用到所有',
    use_this_content: '使用此内容',
    original: '原始',
    edited: '已编辑',
    edited_content_preview: '编辑内容预览',
    apply_edits_to_all_topices: '将编辑应用到所有主题？',
    current_editing_instructions_across_the_whole_course:
      '这将把您当前的编辑指令应用到整个课程。您可以在保存前查看合并预览。',
    edit_content_instructions: '编辑内容指示',
    generate_content_for_this_topic_instruction: '根据指示生成本主题内容',
    descrip_edit_content: '描述如何编辑此内容（例如：缩短、简化、改写）',
    try_short_clear_direcctives: `尝试简短清晰的指令。例如：“保留关键点，缩至 100 字”、“简化语言”、“精简并去掉冗余”。`,
    we_preserve_the_core_meaning: '我们在应用您的指示时保留核心含义。',
    feedback_optional: '反馈（可选）',
    write_your_feedback_here: '在此处撰写反馈',
    from_web: '来自网页',
    from_desktop: '来自桌面',
    pleae_wait_processing: '请稍候，正在处理...',
    create_simulation_from_screen_capture: '从屏幕截图创建模拟',
    sharelook_not_found: '未找到 ShareLook',
    sharelook_screen_capture_application_not_be_opened:
      '无法打开 ShareLook 屏幕截图应用程序。可能未安装在您的计算机上。',
    download_sharelook: '下载 ShareLook',
    launch_sharelook_application: '启动 ShareLook 应用',
    this_will_open_the_sharelook_application_for_screen_capture:
      '这将打开 ShareLook 应用以进行屏幕截图。',
    sharelook_dosenot_open: '如果 ShareLook 未打开，可能未安装在您的计算机上。',
    open_sharelook: '打开 ShareLook',
    download_app: '下载应用',
    background_image_setting: '背景图片设置',
    current_image: '当前图片',
    change_image: '更改图片',
    remove_image: '移除图片',
    no_background_image_selected: '未选择背景图片',
    add_image: '添加图片',
    this_will_open_for_screen_recording:
      '这将打开 ShareLook 应用进行屏幕录制。',
    ai_image_generation: 'AI 图像生成',
    image_edit: '图片编辑',
    text_to_image: '文本转图片',
    output_gallary: '输出图库',
    instant_generation: '立即生成',
    prompt_and_unleash_the_power: '输入提示并释放 AI 的力量',
    use_this_image: '使用此图片',
    error_generating: '生成出错。',
    generation_tips: '生成提示',
    detailed_descriptions_for_more_accurate_results:
      '使用详细描述以获得更精确结果',
    reference_image: '参考图片',
    select_pixel_image: '选择像素图片',
    max_mb: '最大 50MB',
    please_enter_text_to_appear_image: '请输入将显示在图片上的文字',
    enter_text_to_apear_in_the_image: '输入将在图片中显示的文字',
    generate_image: '生成图片',
    prompt_assistant: '提示助手',
    generate_image_using_suggested_prompt: '使用建议的提示生成图片',
    talk_to_ai_about_the_image_generate: '与 AI 讨论您想生成的图片',
    ask_for_prompt_suggestions: '请求提示建议...',
    enter_a_search_term_to_find_stock_images: '输入搜索词以查找图库图片',
    choose_your_content_source: '选择您的内容来源：',
    upload_new_document_from_your_device: '从您的设备上传新文档',
    automatic_library_selection: '自动库选择',
    system_automatically_selects_relevant_document: '系统会自动选择相关文档',
    manual_library_selection: '手动库选择',
    generate_content: '生成内容',
    add_to_current_page: '添加到当前页面',
    generate_bullet_points: '生成要点',
    generating: '生成中',
    this_may_take_a_few_moments: '这可能需要一些时间',
    apply_to_page: '应用到页面',
    scenario_escription: '场景描述：',
    feedback: '反馈',
    form_mode: '表单模式',
    chat_mode: '聊天模式',
    this_will_generate_a_continuation_of_the_seleccted_story:
      '这将使用 AI 生成所选故事的续篇。',
    continue_this_story_question: '继续这个故事？',
    continue_this_story: '继续这个故事',
    what_will_happen: '将会发生的事情：',
    the_ai_will_analyze_the_existing_story_content: 'AI 将分析现有的故事内容',
    generate_a_natural_continuation_that_follows_the_same_tone:
      '生成一个自然的续篇，保持相同的语气和风格',
    create_new_content_that_build_upon_the_current_narrative:
      '创建基于当前叙述的新内容',
    this_process_may_take_a_few_moments_to_complete:
      '此过程可能需要几分钟完成。',
    no_existing_stories_found_for_this_course: '未找到该课程的现有故事。',
    create_your_first_story: '创建您的第一个故事',
    existing_stories: '现有故事',
    create_new_story: '创建新故事',
    tone: '语气',
    style: '风格',
    genre: '类型',
    loading_your_stories: '正在加载您的故事...',
    edit_story: '编辑故事',
    story_preferences: '故事偏好',
    please_input_your: '请输入您的',
    add_character_names_and_press_enter: '添加角色名称并按 Enter',
    select_or_type_your: '选择或输入您的',
    enter_your: '输入您的',
    position_of_the_story_in_the_lesson:
      '故事在课程中的位置。故事将作为模块添加到指定位置。',
    save_previous_content_on_the_pages: '保存页面上的先前内容',
    the_existing_content_in_the_selected_pages:
      '所选页面上的现有内容将被生成的故事替换。',
    real_world_scenario: '真实世界场景',
    add_optional_instructions: '添加可选说明（语气、长度、受众等）',
    ready_to_enerate_your_real_world_scenario: '准备生成您的真实世界场景',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      '点击“生成真实世界场景”，根据课程内容创建一个现实场景。',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI 将分析您的课程主题和内容',
    generate_a_practical_real_world_scenario: '生成一个实用的真实世界场景',
    you_can_then_edit_and_customize_the_result: '您随后可以编辑和自定义结果',
    add_it_as_a_new_page_to_your_lesson: '将其作为新页面添加到课程中',
    regenerate_with_instructions: '根据说明重新生成',
    add_real_world_scenario: '添加真实世界场景',
    generate_real_world_scenario: '生成真实世界场景',
    simulation_has_been_stopped: '模拟已停止！',
    loading_simulation: '正在加载模拟...',
    you_have_exhausted_all_the_attempts: '您已用完所有尝试次数',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      '学习此页面上的场景，并从以下选项中选择正确答案。',
    attempts_limit_reached:
      '已达到尝试次数限制。您可以重新开始，但分数不会被保存。',
    play_again: '再玩一次',
    import_music_from_computer: '从计算机导入音乐。',
    more: '更多',
    no_badge_yet: '尚无徽章',
    competition_filter: '竞赛筛选',
    global_leaderboard: '全球排行榜',
    placeholder_for_the_global_leaderboard: '这是全球排行榜的占位符。',
    badge_editor: '徽章编辑器',
    adjust_the_appearance_of_this_badge_icon:
      '调整此徽章图标的外观。更改仅适用于此徽章。',
    badge_style: '徽章样式',
    the_image_must_be_pixels: '图像必须是 200x200 像素。',
    badge_name: '徽章名称',
    badge_descrription: '徽章描述',
    enter_badge_criteria: '输入徽章标准',
    discard: '丢弃',
    badge_enable: '启用徽章',
    award_users_with_badges_to_highlight_the_milestones:
      '为用户授予徽章，以突出他们学习旅程中的里程碑。',
    badge_types: '徽章类型',
    enable_or_disable_specific_badge_types_for_your_users:
      '为您的用户启用或禁用特定类型的徽章。',
    levels_enabled: '启用等级',
    level_rules: '等级规则',
    points: '积分',
    add_new_level: '添加新等级',
    add_level: '添加等级',
    points_enabled: '启用积分',
    learning_activities_and_encourage_healthy_competition:
      '为不同的学习活动授予用户积分，鼓励健康竞争。',
    award_points: '授予积分',
    the_following_equates_the_value_of_one_item_completion:
      '以下表示完成一个项目的积分值',
    general: '通用',
    others: '其他',
    certificate: '证书',
    quiz_passed: '测验通过',
    tip_approved: '提示已批准',
    tip_liked: '提示已点赞',
    rewards: '奖励',
    offer_discounts_when_learners_achieve:
      '当学习者获得一定的积分、徽章或等级时提供折扣。',
    give_rewards: '给予奖励',
    discount_course_purchases_by: '课程购买折扣',
    with_points_more_than: '积分超过',
    with_badges_more_than: '徽章超过',
    with_level_upwards_more_than: '等级高于',
    leaderboard: '排行榜',
    leaderboard_enabled: '启用排行榜',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      '排行榜为用户提供其学习进度的概览，与他人进行比较。',
    show_levels: '显示等级',
    show_points: '显示积分',
    show_badges: '显示徽章',
    show_courses: '显示课程',
    show_certificates: '显示证书',
    leaderboard_settings: '排行榜设置',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      '设置引人入胜的排行榜体验以提升学习者的积极性。',
    award_users_with_points_for_different_learning_activities:
      '为不同的学习活动授予用户积分。',
    badge_set: '徽章集',
    choose_the_type_of_badges_your_users:
      '选择您的用户在学习过程中将获得的徽章类型。',
    levels: '等级',
    Levels_represent_the_stages: '等级代表用户学习旅程的阶段。',
    enabled: '已启用',
    disabled: '已禁用',
    quick_select: '快速选择',
    yesterday: '昨天',
    last_week: '上周',
    Last_month: '上个月',
    last_quarter: '上个季度',
    historical_leaderboard: '历史排行榜',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      '跟踪您的表现，查看您在同伴中的排名',
    time_period: '时间段',
    page_of: '第 1 页，共 1 页',
    edit_competition: '编辑竞赛',
    create_competition: '创建竞赛',
    arrow_right: '箭头-右',
    update_competition: '更新竞赛',
    competition_title: '竞赛标题',
    enter_competition_title: '输入竞赛标题',
    enter_competition_description: '输入竞赛描述',
    leaderboard_skill: '技能',
    select_a_skill: '选择技能',
    no_skills_found: '未找到技能',
    competition_period: '竞赛周期',
    add_badge_rule: '添加徽章规则',
    create_badge: '创建徽章',
    add_level_rule: '添加等级规则',
    selected_participants: '已选择的参与者',
    no_participants: '没有参与者',
    start_end_date: '开始–结束日期',
    created_date: '创建日期',
    new_competition: '新竞赛',
    competitions_list: '竞赛列表',
    search_competitions: '搜索竞赛...',
    are_you_sure_you_want_to_delete_the_competition: '您确定要删除此竞赛吗',
    history: '历史',
    export: '导出',
    search_by_name: '按名称搜索...',
    no_historical_data_available_for_the_selected_period:
      '所选期间没有可用的历史数据。',
    no_leaderboard_data_available: '没有可用的排行榜数据。',
    competitions: '竞赛',
    leaderboards: '排行榜',
    welcome_back: '欢迎回来',
    track_your_performance_and_see: '跟踪您的表现并查看您与他人的比较',
    team_leaderboard: '团队排行榜',
    try_again: '重试',
    no_competitions_for_search: '没有可用的竞赛',
    no_competitions_available: '没有可用的竞赛',
    no_competitions_matching_search:
      '未找到符合搜索条件的竞赛。请尝试更改搜索词或稍后再试。',
    no_competitions_general:
      '当前没有设置任何竞赛。请稍后再试或联系管理员创建新竞赛。',
    media_management: '媒体管理',
    badgess_set: '徽章集',
    choose_the_default_visual_style_for_badge:
      '选择整个平台徽章图标的默认视觉样式。',
    enable_badges: '启用徽章',
    add_badge: '添加徽章',
    min: '最小',
    max: '最大',
    your_rank: '您的排名',
    your_points: '您的积分',
    your_level: '您的等级',
    rank: '排名 #',
    level: '等级',
    progress: '进度',
    new_folder: '新文件夹',
    file_upload: '上传文件',
    writer: '文档编辑器',
    text_documents: '文本文档',
    spreadsheets: '电子表格',
    impress: '演示文稿',
    presentations: '演示',
    capture_desktop_screen: '捕获桌面屏幕',
    capture_desktop_screens: '捕获桌面屏幕',
    your_documents: '您的文档',
    manage_your_videos_images_audio_files:
      '管理您在内容创作中使用的视频、图片、音频文件和其他资源。',
    your_organization_documents: '您的组织文档',
    keep_your_organization_creative_assets_organized:
      '保持您组织的创意资产有序且可访问——简化团队协作与内容制作。',
    your_public_documents: '您的公共文档',
    curated_collection_of_media_assets_available:
      '一个精心策划的媒体资源合集——可供所有人探索、重用和创作。',
    your_download_center_documents: '您的下载中心文档',
    repository_of_approved_media_assets_for_download:
      '经批准的媒体资源库，可下载并用于您的项目。',
    search_files_and_folders: '搜索文件和文件夹..',
    home: '主页',
    folders: '文件夹',
    folder_name: '文件夹名称',
    owner: '所有者',
    last_updated: '最后更新',
    action: '操作',
    no_folders_found: '未找到文件夹',
    files: '文件',
    enabling_ai: '正在启用 AI...',
    rename: '重命名',
    copy: '复制',
    move: '移动',
    verson_history: '版本历史',
    manage_permission: '管理权限',
    generate_audit_report: '生成审计报告',
    last_edited: '最后编辑',
    no_files_found: '未找到文件',
    are_you_sure_you_want_to_make_this_item_public:
      '您确定要将此项目设为公开吗？它将被复制到您的公共库中。',
    move_to_organization: '移动到组织',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      '您确定要将此项目复制到您的组织库吗？',
    are_you_sure_you_want_to_make_this_item_private:
      '您确定要将此项目设为私有吗？它将被复制到您的个人库中。',
    date_modified: '修改日期',
    workflow_management: '工作流程管理',
    configure_editors_approvers_and_viewers_for_this_document:
      '为此文档配置编辑者、审批者和查看者。',
    error_Loading_editor: '加载编辑器出错',
    debug_info: '调试信息',
    loading_editor: '正在加载编辑器...',
    submitted_for_review: '已提交审核',
    editors: '编辑者',
    no_editors_added_yet: '尚未添加编辑者。点击“添加编辑者”以添加。',
    add_editor: '添加编辑者',
    approvers: '审批者',
    no_approvers_added_yet: '尚未添加审批者。点击“添加审批者”以添加。',
    add_approvers: '添加审批者',
    viewer: '查看者',
    no_viewers_added_yet: '尚未添加查看者。点击“添加查看者”以添加。',
    add_viewer: '添加查看者',
    are_you_sure_you_want_to_delete_the_selected_items:
      '您确定要删除所选项目吗？'
  },
  v3: {
    reportShareSphere: '分享领域',
    overview: '类别概览',
    triviaReport: '分享领域类别',
    overviewGraph: '类别概览图表',
    category: '类别',
    phCategory: '选择类别',
    podcast: '播客、音乐与故事',
    pastPodcast: '过去的播客',
    upcomingPodcast: '即将播出的播客',
    podcastLanguageTitle: '播客、音乐与故事语言',
    podcastLanguageCheckbox: '为我的播客使用AI生成语言',
    howRate: '您如何评价这个播客？',
    podcastSubmit: '提交',
    podcastGuest: '嘉宾讲者：',
    podcastReview: '评论',
    podcastEpishode: '集数',
    podcastEnd: '播客已结束',
    date_podcast: '播客日期',
    skill_not_found: '抱歉！未找到技能旅程。',
    coaching: '辅导',
    webinar: '网络研讨会',
    public_conference: '公开会议',
    skill_journey_subtitle:
      '添加您的技能旅程设置，并选择谁可以查看和互动您的技能旅程。',
    enable_white_label: '启用白标',
    create_new_event_org: '为您的组织创建新活动',
    create_new_event_marketplace: '为市场创建新活动',
    create_new_event_both: '为您的组织和市场创建新活动',
    event_outline: '请输入活动大纲',
    event_obj: '请输入活动目标',
    event_description: '请输入活动描述',
    create_new_metamaze_org: '为您的组织创建新MetaMaze',
    create_new_metamaze_marketplace: '为市场创建新MetaMaze',
    create_new_metamaze_both: '为您的组织和市场创建新MetaMaze',
    add_key_words: '添加关键词',
    press_enter_make_keyword: '按回车键创建关键词',
    disable_skip_quiz: '禁用跳过测验',
    warning_complete_quiz: '请完成测验以继续。',
    signup_email_verification:
      '我们已向您提供的邮箱发送了验证链接。请访问该链接以验证您的注册。',
    verifying_registration: '正在验证账户注册……',
    reset_password_linK:
      '我们已向您提供的邮箱发送了密码重置链接。请访问该链接以设置新密码。',
    reset_email_error: '未找到该邮箱对应的用户，请尝试使用用户名重新操作！',
    first_name: '名',
    last_name: '姓',
    error_firstName: '请输入您的名字',
    error_sharebot_organization: '请输入您的组织',
    error_lastName: '请输入您的姓氏',
    private_conference: '私人会议',
    public_conference: '公开会议',
    discussion_room: '讨论室',
    training_no_courses: '您当前没有参加任何课程。',
    training_no_events: '您当前没有参加任何活动',
    allow_sharing_trainer_info: '允许市场分享电子邮件地址',
    error_username_space: '用户名中不能包含空格。',
    error_sharebot_organization_space: '组织名中不能包含空格。',
    edit_permission: '编辑权限',
    valid_price: '价格必须大于0',
    course_price_message: `*课程只对组织购买的用户开放，且不得在市场转售`,
    valid_edit_price: '编辑价格必须低于购买价格。',
    my_calendar: '我的日历',
    error_valid_firstName: '请输入有效的名字。',
    error_valid_organization: '请输入有效的组织名。',
    error_valid_lastName: '请输入有效的姓氏。',
    error_name_spaces: '名字中不能包含空格',
    items: '项目',
    publish_to_channel: '发布到我的频道合集',
    create_a_channel: '创建我的频道',
    create_a_trivia: '创建问答游戏',
    create_a_new_channel: '创建新频道',
    add_videos: '添加视频',
    save_and_continue: '保存并继续',
    channel: '频道',
    channels: '频道',
    view_channel: '查看频道',
    edit_channel: '编辑频道',
    delete_channel: '删除频道',
    my_video_channels: '我的视频频道',
    training_no_channel: '您当前没有参加任何频道。',
    monthly_price_required: '需要月费',
    yearly_price_required: '需要年费',
    one_time_price_required: '需要一次性价格',
    marketplace_quantity: '美元',
    report_webinar: '网络研讨会',
    report_coaching: '辅导',
    report_channel: '频道',
    report_public_conference: '公开会议',
    report_maze: '迷宫',
    channel: '频道',
    edit_price: '编辑价格 ($)',
    quantity: '数量',
    payment_type: '支付类型',
    total_amount: '总金额 ($)',
    net_amount: '净金额 ($)',
    edit_option: '编辑选项',
    marketplace_price: '价格 ($)',
    market_name: '名称',
    duration_min: '时长（分钟）',
    users_total: '用户数（总计）',
    sales_total: '总销售额（美元）',
    search_coaching: '搜索辅导',
    search_channel: '搜索频道',
    search_webinar: '搜索网络研讨会',
    search_maze: '搜索迷宫',
    search_public_conference: '搜索公开会议',
    buyer_type: '买家类型',
    quanity: '数量',
    channel_unit_amount: '净金额 ($)',
    channel_updated_at: '更新时间',
    month_price: '价格（月）',
    year_price: '价格（年）',
    one_time_price: '价格（一次性）',
    sharebot_organization: '添加新组织名',
    share_sphere: '分享领域',
    ai_course_title: '课程标题',
    ai_input_course_title: '请输入课程标题！',
    learning_objective_label: '学习目标',
    learning_objective_message: '请输入学习目标！',
    standard_question: '学习者需要遵守任何标准吗？',
    standard_details_label: '标准详情',
    standard_details_message: '请输入标准详情！',
    estimated_duration_label: '课程预计时长（分钟）',
    estimated_duration_message: '请输入课程预计时长！',
    min_duration_message: '最短时长为 5 分钟。',
    ai_mins: '25 分钟',
    industry_specific_question: '这是特定行业的吗？',
    industry_label: '请注明行业',
    industry_message: '请输入行业！',
    ai_course_creation: 'AI课程创建',
    course_generated: '课程由 Sharelook 生成',
    ai: 'AI',
    ai_you: '你',
    ai_prompt_ready: '你的提示已准备好。你现在可以生成课程目录。',
    ai_unable_respond: '很抱歉！AI 无法响应你的提示。请再试一次。',
    ai_hide_toc: '隐藏课程目录',
    ai_preview_toc: '预览课程目录',
    ai_generate_toc_now: '立即生成课程目录',
    ai_creation_course_title: '课程标题：',
    ai_creation_industry_specific: '是否为特定行业：',
    ai_creation_industry: '行业：',
    ai_creation_standard_needed: '是否有学习者需要遵循的标准？：',
    ai_creation_standard_details: '标准详情：',
    ai_creation_estimated_duration: '课程预计时长（分钟）：',
    minutes: '分钟',
    ai_creation_learning_objective: '学习目标：',
    setup_again: '重新设置',
    ai_creation_confirm_title: '你确定要重新设置表单吗？',
    ai_creation_confirm_content: '聊天记录和所有已生成内容将被重置。',
    ai_toc: '课程目录',
    ai_note_topic: '注意：你可以拖放以重新排序课程中的主题。',
    ai_add_topic: '+ 添加主题',
    add_topic: '添加主题',
    add_lesson: '添加课程',
    add_new_lesson: '添加新课程',
    ai_add_lesson: '+ 添加课程',
    attention: '注意',
    before_varifying: '验证前',
    ai_save_later: '稍后保存',
    ai_download_word_doc: '下载为 Word 文档',
    ai_download_course_word_doc: '将课程下载为 Word 文档',
    ai_create_course_button: '创建课程',
    ai_generate_course_content: '生成课程内容',
    ai_out_of: '共',
    ai_subtopic_failed_content:
      '部分子主题未能生成内容。点击“生成课程内容”重新生成这些子主题的内容。',
    ai_edit_topic: '编辑主题',
    ai_edit_lesson_title: '编辑课程标题',
    ai_save_topic: '保存主题',
    ai_save: '保存',
    ai_save_lesson_title: '保存课程标题',
    ai_add_new_topic: '添加新主题',
    ai_download_ref: '带引用下载',
    ai_download_ref_content: '课程将以带引用的 Word 文档下载。',
    ai_download_without_ref: '无引用下载',
    ai_download_two_word: '将下载两个 Word 文档：',
    ai_download_two_word_content_one: '- 一个包含无引用的主要内容，',
    ai_download_two_word_content_two: '另一个仅包含引用列表，无内容。',
    ai_manage_content: '管理内容',
    ai_add_content_from_internet: '+从互联网添加内容',
    ai_confirm_start: '确认开始',
    ai_Verify: '验证',
    ai_undo_warning:
      '此过程可能需要一些时间。在生成完成之前请不要关闭此窗口，此操作不可撤销。',
    ai_verified_content:
      '你已验证内容。确认后将无法与 AI 助手就当前内容继续对话。',
    ai_want_proceed: '你确定要继续吗？',
    upload_simulation: '上传模拟',
    name_simulation: '模拟名称',
    selected_simulation_files: '选中的模拟文件',
    score_between_one_hundred: '你的分数应在 1 到 100 之间。',
    are_sure_simulation: '你确定要删除这个模拟文件吗？',
    required_simulation: '分数为必填项',
    required_section_file: '章节文件为必填项',
    simulation: '模拟',
    simulation_quiz_games: '需要在游戏中添加测验',
    simulation_alert_des:
      '只有当所有问题的答案类型为单选或多选时才能添加游戏。',
    alert_info: '信息',
    ai_number_quiz: '测验数量',
    ai_point: '得分',
    ai_points: '分数',
    val_required: '必填',
    games: '游戏',
    add_simulation: '添加模拟',
    text_tiewer: '文本查看器',
    back_to_account: '返回账户',
    delete_account: '删除账户',
    delete_account_title: '删除账户？？？',
    delete_account_subtitle: '你可以在此处删除账户。',
    delete_account_cannot_undo: '你将永久删除账户，此操作不可撤销。',
    account_org_profile: '你将失去所创建的所有课程、组织资料和所有设置。',
    deleting_account_database: '删除账户将从我们的数据库中移除所有你的数据。',
    account_confirm_delete: '你确定要删除账户吗？',
    action_cannot_be_undone: '此操作不可撤销。',
    account_delete_message_success: '你的账户已成功删除。',
    message_edit: '编辑',
    message_delete: '删除',
    message_reply: '回复',
    attached_file: '附件',
    attach_file: '附加文件',
    attach_des: '最大文件大小为25MB',
    view: '查看',
    go_to_marketplace: '前往市场',
    learning_center: '学习中心',
    knowledge_center: '知识中心',
    sharebot: 'ShareBot',
    sharebot_help_message: '我今天可以帮你做些什么？',
    my_organization: '我的组织',
    world_knowledge: '世界知识',
    welcome_to_sharelook: '欢迎来到 Sharelook！',
    sharelook_you_want_go: '你今天想去哪里？',
    shareLook_learning_management_system:
      '访问 ShareLook 学习管理系统，在你的组织中创建或访问课程和实时活动。',
    shareLook_powerful_ai_system:
      '访问 ShareLook 的强大 AI 系统，可上传 PDF 文件并在几秒钟内获取有用见解。',
    edit_now: '立即编辑',
    sharelook_log_out: '你已退出 Sharelook，请重新登录！',
    sorry_error: '很抱歉！我们遇到了一些错误。',
    login: '登录',
    refresh_page: '刷新页面',
    just_a_moment: '请稍候',
    enter_lname_fname: '请输入你的名字和姓氏以继续。',
    procced_to_sharelook: '继续前往 Sharelook',
    option_one: '选项一',
    option_two: '选项二',
    selected_image: '已选图片：',
    add_text: '添加文本',
    linkdin_is_required: 'LinkedIn 为必填项。',
    bio_is_required: '简介为必填项。',
    save_user_information: '保存用户信息',
    select_all: '全选',
    enable_ai: '启用 AI',
    load_more: '加载更多',
    channel_id: '频道 ID。',
    send: '发送',
    v4: '信息',
    subscription: '订阅',
    reset_user_flag: '重置用户标志',
    delete_my_accont: '删除我的账户',
    sharebot_sub_error: '获取订阅信息时出错。请重试！',
    sharebot_no_sub: '你当前没有任何有效订阅。',
    sharebot_dont_sub: '你没有任何历史订阅。',
    sharebot_prev_sub: '以前订阅的',
    sharebot_sub: 'ShareBot 订阅',
    sharebot_un_sub: 'ShareBot 退订',
    sharebot_no_available: '无可用描述',
    sharebot_start_date: '开始日期：',
    sharebot_end_date: '结束日期：',
    sharebot_sure: '你确定吗？',
    sharebot_do_you_want: '你想',
    unsubscribe: '取消订阅',
    unsubscribe_what: '取消订阅？',
    subscribe: '订阅',
    subscribe_what: '订阅？',
    subscribe_now: '立即订阅',
    confirm: '确认',
    sharebot_intel_knowledge_center: 'ShareBot 智能知识中心',
    sharebot_welcome_paragraph:
      '欢迎来到 ShareBot 知识中心，这是一个先进的 AI 聊天机器人，旨在彻底改变专业人士获取信息和协作的方式。',
    expired: '已过期',
    active: '活跃',
    Inactive: '非活跃',
    yearly_subscription: '年付订阅',
    monthly_subscription: '月付订阅',
    no_sharebot_org: '你没有 ShareBot 组织',
    sharebot_start_free_trial: '开始免费试用',
    sub_month: '月度订阅',
    sub_year: '年度订阅',
    question_per_month: '1TB 数据存储，每月 1000 个问题',
    sharebot_para:
      '继续操作即表示你确认立即删除组织。此操作将导致失去所有 ShareBot 提供的宝贵见解，且无法撤销。',
    cancelled_date: '取消日期：',
    live_straming_para: '如果你希望更改月度直播限制，请联系',
    sharelook_agree: '我同意 Sharelook 的',
    terms_condition: '条款与条件',
    and: '和',
    privacy_policy: '隐私政策',
    save_for_later: '稍后保存',
    ai: 'AI',
    no_video_yet: '尚未选择视频！',
    are_you_sure_delete_video: '你确定要删除此视频吗？',
    video_des: '描述',
    video_now: '现在',
    video_playing: '正在播放：',
    video_no: '视频编号',
    ai_generated_course: 'AI 生成的课程',
    create_course_on_our_own: '自行创建课程',
    ai_Assisted_ourse_reation: 'AI 辅助课程创建',
    pending: '待处理',
    published: '已发布',
    intro_course: '到你的课程中？',
    clone_course: '你想克隆',
    browser_audio_not_support: '你的浏览器不支持音频标签。',
    audio_popup_content:
      '你可以在此输入文字并使用多种语音风格播放，Lorem Ipsum 是印刷和排版行业的虚拟文本标准……',
    close: '关闭',
    podcast_rec: '录音',
    create_podcast: '创建播客',
    add_admin: '添加管理员',
    delete_all: '全部删除',
    ai_podcast_audio: 'AI 播客音频',
    language: '语言',
    podcast_download_content:
      '*下载 AI 音频文件后可进行编辑，成为你的音频文件。',
    upload_audio: '上传音频',
    browser_do_not_support_audio: '你的浏览器不支持音频元素。',
    upload_cover: '上传封面',
    upload_ai_creator: 'AI 创建者',
    required_cover_image: '封面图片为必填项！',
    room_required_name: '播客名称为必填项！',
    add_guest_list: '请添加嘉宾列表！',
    podcast_add_participants: '添加参与者',
    topic_required: '至少需要一个主题',
    podcast_description: '描述',
    podcast_date: '日期',
    date: '日期',
    podcast_time: '时间',
    podcast_to: '至',
    podcast_all_day: '全天',
    podcast_start_date_time: '开始日期和时间间隔为必填项！',
    podcast_id: 'ID',
    selected_user: '邀请选中用户',
    see_more: '查看更多',
    see_less: '收起',
    no_review_yet: '尚无评论，快来发表第一条吧。',
    request_to_speak: '接受用户发言请求？',
    kick_user: '你想将此用户踢出吗？',
    accept_request: '接受请求',
    kick: '踢出',
    started: '已开始',
    end: '结束',
    join_now: '立即加入',
    podcast_end: '播客已结束',
    connecting: '连接中...',
    knowledge_center_know_today: '你今天想了解什么？',
    knowledge_center_question: '请先输入问题',
    knowledge_center_error: '很抱歉！我们遇到了一些错误。',
    knowledge_center_tooltrip:
      '从你组织资源库中快速获取有引用的答案，并可预览或下载引用的 PDF 文档。',
    open_file: '打开文件',
    reference: '引用',
    are_you_cancel: '你确定要取消吗？',
    are_you_remove_media: '你确定要移除此媒体吗？',
    terms_agree: '我同意这些',
    ready: '准备好了',
    send_email: '发送邮件',
    active_users: '活跃用户',
    sign_up_user: '已注册用户',
    non_sign_up_user: '未注册用户',
    organisation: '组织',
    usage_report: '使用报告',
    check_email: '检查你的电子邮件',
    delete_schedule: '删除日程',
    are_you_sure_delete_schedule: '你确定要删除此日程吗？',
    add_task: '请输入任务！',
    coaching_available: '标记为可辅导时间',
    message_booking_coaching: '该时段已被预定为辅导。',
    task_day: '任务日',
    created_task_day: '你已为该日创建任务。',
    event_day: '活动日',
    has_booked_coaching: '该日已有辅导预约。',
    active_day: '活跃日',
    selectable_time_slots: '右侧可选时间段为该日有效。',
    compare_last_month: '与上月比较',
    uploading_file: '正在上传你的文件',
    attach_file_course: '附加到此课程。',
    fetch_request: '获取你的请求',
    finilize_upload: '完成上传',
    scorm_scanned: '请稍候……你上传的 SCORM zip 正在扫描中。',
    scan_status: '扫描状态：',
    scan_completed: '扫描完成。你的文件是',
    scan_progress: '扫描进行中……',
    check_scorm: '正在检查你的 SCORM 文件格式……请稍候……',
    file_check_success: '文件检查成功',
    file_check_progress: '文件检查进行中……',
    scorm_not_upload: '你上传的文件不符合 SCORM 1.2 标准，请重新上传。',
    select_question: '答案选项（选择一个正确答案）',
    select_answer: '请选择答案选项！',
    check_option_one: '请输入选项一！',
    check_option_two: '请输入选项二！',
    check_option_three: '请输入选项三！',
    check_option_four: '请输入选项四！',
    question_image: '问题图片',
    select_question_image: '请选择问题图片！',
    ans_image: '答案图片',
    upload_image_question: '上传答案图片',
    select_image_answer: '请选择答案图片！',
    save_question: '保存问题',
    do_you_leave: '你确定要离开吗？',
    loose_all_progress: '你将失去所有进度。',
    welcome: '欢迎',
    team_knowledge_quest: '团队知识竞赛',
    your_score: '你的得分',
    start_playing: '开始游戏',
    share_sphere_complete: 'ShareSphere 完成',
    final_score: '最终得分',
    play_next: '继续游戏',
    you_donot_access_event: '你无权访问此活动。',
    ai_content_generated: '本主题内容已生成。',
    ai_popup_confirm_content: '确认生成内容',
    limit_transcribe_text:
      '剩余转录时间：<0>{{ transcribe_limit }}</0> 分钟 <1/><2/> <3>。如需更改转录限制，请联系 </3> <4>admin@sharelook.com</4>。',
    you_donot_access_event: '您无权访问此活动。',
    ai_course_title_training: '领导力培训课程',
    ai_course_object: '数字时代的领导力探索',
    create_ai_video: '创建 AI 视频',
    generate: '生成',
    video_generate_process:
      '视频生成过程可能需要一些时间。完成后我们会通过邮件通知您。',
    stripe_account_connect: '您的 Stripe 账户未激活。请连接或激活以继续使用。',
    ai_creator: 'AI 创作者',
    check_video_status: '正在检查视频生成状态...',
    video_on_queue: '视频生成排队中。',
    video_fail_generation: '很抱歉，视频生成失败。请尝试其他内容。',
    video_currently_generated: '该视频正在生成中。',
    checking_status: '正在检查状态',
    check_status: '检查状态',
    browser_does_not_support_audio: '您的浏览器不支持 audio 标签',
    existing_edit_scenario:
      '您想编辑现有场景还是创建新场景？如果创建新场景，旧场景将会丢失。',
    generate_scenario: '生成场景',
    layout: '布局',
    confirm_change: '确认更改',
    generated_ai_creation_message:
      '请注意，仅会保留通过 AI 创建生成的文本元素，其他所有元素将从页面中移除。',
    generate_story: '生成故事',
    save_original_content: '保存原始内容：',
    story_added_specified_position:
      '故事在课程中的位置。故事将作为区块添加到指定位置。',
    position_of_story: '故事位置',
    start_the_lesson: '课程开始',
    end_the_lesson: '课程结束',
    add_story_pages: '将故事添加到页面',
    browser_does_not_support: '您的浏览器不支持音频元素。',
    no_video_available: '暂无可用视频。',
    no_podcast_available: '暂无可用播客。',
    no_item_baskets: '购物篮中没有物品。',
    ai_course_object: '数字时代的领导力探索'
  },
  v2: {
    n_data: '无数据',
    change: '更改',
    remove: '移除',
    auto_background: '自动背景',
    create_new_course_org: '为您的组织创建新课程。',
    create_new_course_marketplace: '为市场创建新课程。',
    create_new_course_both: '为您的组织和市场创建新课程。',
    ok: '确定',
    page_bg: '页面背景',
    lesson_cover: '课程封面图片',
    create_skill_journey: '创建技能旅程',
    Metamaze: 'Metamaze',
    events: '活动',
    scroms: 'SCORM课程',
    min_score_pass: '及格最低分数',
    no_scorms_available: '暂无SCORM课程。',
    no_events_available: '暂无活动。',
    no_courses_available: '暂无课程。',
    no_courses_baskets: '购物篮中没有课程。',
    no_mazes_baskets: '购物篮中没有迷宫。',
    no_scroms_baskets: '购物篮中没有SCORM课程。',
    no_events_baskets: '购物篮中没有活动。',
    sorry: '对不起！',
    option_1: '选项 1',
    option_2: '选项 2',
    enter_number_words: '请输入最多单词数量。',
    summarize: '总结',
    answer: '回答',
    hold_tight_one_minute: '请稍等！我们正在准备中，可能需要一分钟时间。',
    enter_question: '请输入您的问题。',
    enter_relevant_documents: '请输入相关文档数量。',
    please_input_relevant_documents: '请输入相关文档数量！',
    please_wait_loading_results: '请等待结果加载中...',
    proceed_to_add_voice: '继续添加语音',
    results: '结果',
    no_result_found_try_asking_questions: '未找到结果。请尝试提问其他问题。',
    eg: '例如：',
    what_make_sales_manager: '我如何成为销售经理？',
    please_select_lang: '请选择一种语言！',
    search: '搜索',
    please_copy_desired_content: '请将所需内容从左侧框复制到右侧框。',
    rating_req: '评分为必填项。',
    review_req: '评论为必填项。',
    rating_review_req: '必须提供评分和评论。',
    how_rate_this: '您如何评价这个？',
    amazing_above_expectations: '太棒了！超出预期！',
    certificates: '证书',
    you_no_certificates: '您目前没有可用的证书。',
    please_add_review: '请提供评分和评论，谢谢！',
    post: '发布',
    rate: '评分',
    avg_rating: '平均评分',
    no_review_found: '未找到评论',
    are_sure_to_disale_zoom_integration: '您确定要禁用 Zoom 集成吗？',
    badges: '徽章',
    you_no_badge_available: '您目前没有可用的徽章。',
    download_certificate: '下载证书',
    loading: '加载中...',
    no_file_attached: '未附加文件',
    you_do_not_have_any_notes: '您还没有笔记。',
    question: '问题',
    score: '分数',
    alert_score_message: '有人已提交他们的分数。',
    alert_question_message: '尚未添加问题。',
    button_submit: '提交',
    button_allScores: '所有分数已提交。',
    record_wait: '录音即将开始，请稍等...',
    buttonSubmit_warning: '请在提交前输入所有分数。',
    upload_ar_assets: '上传AR资产',
    edit_ar_assets: '编辑AR资产',
    edit_maze_assets: '编辑MetaMaze资产',
    upload_assets: '上传资产',
    upload_maze_assets: '上传MetaMaze资产',
    trigger_title: '触发器标题',
    model_title: '模型标题',
    trigger_description: '触发器描述',
    model_description: '模型描述',
    please_type_target_description: '请输入目标描述。',
    please_type_model_description: '请输入模型描述。',
    trigger_image: '触发器图片*',
    model_image: '模型图片*',
    upload_trigger_image: '上传触发器图片',
    upload_model_image: '上传模型图片',
    drag_n_drop: '拖放',
    file_size_should_not_exceed: '(图片文件（JPEG）大小不得超过512 KB)',
    zip_size_should_not_exceed: '(压缩文件大小不得超过60 MB)',
    ar_content: 'AR内容*',
    model_content: '3D模型*',
    upload_3d_zip: '上传ZIP / 视频',
    upload_3d_maze_zip: '上传ZIP',
    audio_content: '音频内容',
    _mp3: '(.mp3)',
    content_attached: '已附加压缩包。',
    video_attached: '已附加视频。',
    audio_attached: '已附加音频。',
    enter_trigger_image_title: '输入触发器图片标题。',
    enter_model_title: '输入MetaMaze模型标题。',
    ar_preview_image: 'AR预览图片',
    upload_preview_image: '上传预览图片',
    upload_audio: '上传音频',
    creating___: '正在创建...',
    updating___: '正在更新...',
    create: '创建',
    update: '更新',
    ar_assets: '3D图片',
    _3d_files_mp4: '(压缩的 .obj, .fbx 或 .mp4 视频)',
    _3d_files_mp4_ar: '(压缩的 .obj, .fbx)',
    maze_3d_files_mp4: '(压缩的 .obj, .fbx)',
    _jpg_files: '仅支持 .jpg',
    persons_have_submitted_their_scores: '人员已提交他们的分数。',
    no_questions_added_till_now: '目前尚未添加问题。',
    submit: '提交',
    all_scores_submitted: '所有分数均已提交。',
    recording_is_starting: '录制正在开始，请稍候...',
    please_input_scores_before_submitting: '请在提交前输入所有分数。',
    end_for_all: '结束所有',
    full_screen: '全屏',
    breakout_room: '分组讨论室',
    send_invitations: '发送邀请',
    add_participants: '添加参与者',
    create_breakout_room: '创建分组讨论室',
    connecting: '连接中...',
    currently_broadcaster_unavailable: '当前主播不可用。',
    how_many_breakout_room_to_create: '您想创建多少个分组讨论室？',
    create_upto_three_breakout_rooms: '*最多创建3个分组讨论室',
    allow: '允许',
    additional: '附加',
    attachment: '附件',
    no_description_available: '无可用描述。',
    people: '人员',
    waiting: '等待中',
    hand_raising_users: '举手用户',
    invite: '邀请',
    create_room: '创建房间',
    create_live_event: '创建直播活动',
    support_upto_fivethousand_participants: '支持最多5000名参与者的活动',
    support_upto_ten_participants: '支持最多10名直播视频参与者',
    support_upto_twohundred_participants: '支持最多200名参与者的活动',
    supprt_upto_five_participants: '支持最多5名直播视频参与者',
    support_upto_twentyfive_participants: '支持最多25名直播视频参与者',
    two_live_video_participants: '活动中有2名直播视频参与者（主持人和与会者）',
    you_can_have_upto_five_examinees: '您最多只能有5名考生。',
    you_can_have_upto_twentyfive_participants: '您最多只能有25名参与者。',
    you_can_have_upto_five_participants: '您最多只能有5名参与者。',
    you_can_have_upto_ten_participants: '您最多只能有10名参与者。',
    select_hosts_email: '选择主持人邮箱',
    send_invite_email: '发送邀请邮件',
    do_not_send_invite_email: '不发送邀请邮件',
    error: '错误',
    max_twentyfive_users_allowed: '最多允许选择25名用户',
    max_five_users_allowed: '最多允许选择5名用户',
    max_ten_users_allowed: '最多允许选择10名用户',
    no_user_found: '未找到用户',
    transcribe_to: '转录为',
    integrate_zoom_to_start_meeting: '请在您的账户中集成Zoom以开始Zoom会议。',
    zoom_is_not_integrated: '未集成Zoom。',
    delete_poll: '删除投票',
    add_poll: '添加投票',
    live_now: '正在直播！',
    average_rating: '平均评分',
    review: '评论',
    time_spent: '花费时间',
    total: '总计',
    mins: '分钟',
    no_data: '此测验暂无数据。',
    total_score: '总分',
    pass_score: '及格分数',
    point: '分数',
    wrong: '错误',
    response: '回答',
    submitted: '已提交',
    average: '平均',
    total_play: '总播放次数',
    view_graph: '查看图表',
    time_spent_mins: '花费时间（分钟）',
    play: '播放',
    ideal_path: '理想路径',
    user_incorrect_path: '用户错误路径',
    ideal_path_taken: '用户选择的理想路径',
    scenario: '场景',
    option: '选项',
    spend: '花费',
    average_spending_time: '平均花费时间',
    activity_overview: '活动概览',
    live_event: '直播活动',
    live_assessment: '直播评估',
    report_download: '报告下载',
    all_workshops: '所有研讨会',
    overview_average_activity: '活动平均概览',
    overview_workshop_graph: '研讨会概览图表',
    mazes: '迷宫',
    correct_feedback: '正确反馈',
    incorrect_feedback: '错误反馈',
    checkin_checkout: '签到 - 签退',
    minutes: '分钟',
    incorrect_path: '错误路径',
    answer_not_available: '答案不可用',
    views: '观看次数',
    item: '项目',
    questions: '问题',
    total_points: '总积分',
    total_attempts: '总尝试次数',
    created_date: '创建日期',
    host_name: '主持人姓名',
    host_section: '主持人部分',
    choose_products: '选择产品',
    add_to_basket: '加入购物篮',
    basket: '购物篮',
    times: '次数',
    scorms: 'SCORMs',
    skill_journey_overview: '技能旅程概览',
    how_to_use: '使用方法',
    live_broadcast_description: '我们已将直播视频集成到易于使用的课程创建器中',
    live_broadcast_subdescription:
      '通过ShareLook的专利直播系统，您可以创建互动、自动化学习，并最大化知识分享。',
    disclaimer: `我保证我的技能旅程不会：
  - 侵犯任何第三方的权利
  - 包含任何违法内容，包括诽谤、猥亵、不雅、淫秽、色情、暴力、虐待、侮辱、威胁或歧视内容，即使用星号掩盖
  - 包含对他人的人身攻击
  - 冒充其他参与者、公众人物或名人
  - 未经相关个人同意，包含任何个人信息或录音，且不违反世界任何地区的数据保护法规
  - 包含任何商业推销或任何形式的“垃圾信息”`,
    price: '价格',
    video_link: '视频链接',
    category: '类别',
    objectives: '目标',
    marketplace_description: '市场描述',

    live_discussion: '直播讨论',
    poll: '投票',
    hide_grid: '隐藏网格',
    show_grid: '显示网格',
    stop_screen_share: '停止屏幕共享',
    screen_share: '屏幕共享',
    mute: '静音',
    unmute: '取消静音',
    raise_hand: '举手',
    waiting__: '等待中...',
    audio_active: '音频已激活'
  },
  general: {
    save: '保存',
    autosaved: '自动保存',
    back_to: '返回到',
    by: '通过',
    chat: '聊天',
    completed: '完成',
    canceled: '取消',
    component: '组件',
    confirm: '确认',
    course: '课程',
    skill: '技能之旅',
    maze: '元迷宫',
    channel: '频道',
    podcast: '播客',

    date: '日期',
    details: '详情',
    empty: '没有数据',
    enrolled: '登记',
    free: '空闲的',
    graph: '图表',
    loading: '加载中...',
    lesson: '课',
    lessons: '课程',
    live_assessment: '直播评估',
    live_event: '直播活动',
    no: '否',
    of: '关于',
    or: '或',
    organization: '组织',
    page: '页面',
    pages: '页数',
    personal: '个人的',
    poll: '投票',
    rating: '评分',
    reset: '重置',
    signin: '登录',
    signup: '注册',
    soon: '不久',
    type: '类型',
    uploading: '上传...',
    yes: '是',
    something_went_wrong: '某些地方发生错误!',
    view_all: '查看全部',
    upload_successful: '上传成功',
    upload_successful_message:
      '您的excel 文档已成功上传，目前正在处理中。这可能需要一点时间。',
    check_email_upload_successful:
      '请<0>查看您的电子邮件</0>以获取上传用户列表的<1>报告</1>。',
    is_private: '私有的'
  },

  account: {
    title: '账户',
    subtitle: '管理您的设置和帐户信息。',
    saved: '账户更改成功'
  },

  assessments: {
    title: '评估',
    subtitle: '创建一个评估',
    finished: '评估完成',
    countdown: '直播评估将播送 ',
    create: '创建评估',
    list_title: '你的评估',
    delete_warning: '是否确认要删除此项目?',
    details_title: '添加评估详情',
    details_subtitle: '命名你的评估，并且告诉你的听众他们应该从中获得什么。',
    disclaimer: `我保证我记录的评估不会:
    -侵犯任何第三方的权利
    -包含任何违法行为，包括诽谤、淫秽、不雅、淫秽、色情、暴力、辱骂、侮辱、威胁或歧视性内容，甚至用星号伪装
    - 包含对他人的人身攻击
    - 包含任何模仿其他参与者、公众人物或名人的行为
    - 未经任何个人同意，包含任何个人的任何记录或个人信息，且不违反世界任何地区的任何数据保护法规
    - 包含任何商业招标或任何形式的“垃圾邮件”'`,
    assessment_details: '评估详情',

    assessment_settings: '评估设置'
  },

  buildersettings: {
    title: '发布设置',
    subtitle: '向您的活动添加设置，谁可以查看您的活动并与您互动'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: '添加',
    add_page: '添加页面',
    add_lesson: '添加课程',
    add_answer: '添加新答案',
    add_group: '添加组',
    add_organization: '添加组织',
    add_question: '添加问题',
    add_quiz: '添加测试',
    add_users: '添加用户',
    back: '返回',
    back_to_course: '返回到课程概述',
    back_to_lesson: '返回到每课概述',
    back_to_media: '返回到媒体库',
    back_to_details: '返回到详情',
    cancel: '取消',
    clear: '清除',
    close: '关闭',
    clone: '复制',
    close_lesson: '复制课',
    clone_course: '复制课程',
    confirm: '确认',
    create: '创建',
    download: '下载',
    download_mass_user_tamplate: '下载模板',
    add_mass_users: '添加大量用户',
    upload_excel_list: '上传Excel表格',
    delete: '删除媒体',
    edit: '编辑',
    edit_course: '编辑课程',
    enroll: '注册',
    finish: '完成',
    upload_image: '上传图片',
    upload_image_video: '上传图片或视频',
    select_media_library: '选择媒体库',
    make_public: '公开',
    make_private: '隐私',
    make_org: '创建组织',
    media: '媒体库',
    my_theme: '我的主题',
    next: '下一个',
    next_lesson: '下一课',
    next_step: '下一步',
    previous_step: '上一步',
    publish: '发布',
    publish_assessment: '发布您的评估',
    publish_course: '发布您的课程',
    publish_event: '发布您的活动',
    reset: '重置',
    reset_elements: '重置内容',
    save: '保存',
    creating: '正在创建...',
    updating: '正在更新...',
    saved: '已保存',
    save_for_later: '稍后保存',
    save_settings: '保存设置',
    select_files: '选择文件',
    select_theme: '选择主题',
    start_lesson: '开始课程',
    update: '更新',
    upload: '上传',
    upload_audio: '上传音频',
    upload_photo: '上传个人资料照片',
    upload_video: '上传视频',
    enrolled: '已注册',
    unenroll: '取消注册',
    from_library: '媒体库',
    remove: '删除',
    removed: '已删除',
    start_broadcast: '开始播放',
    end_broadcast: '结束播放',
    camera: '摄像头',
    screen: '屏幕',
    screen_with_camera: '带摄像头的屏幕'
  },

  card: {
    quick_add: '快速添加',
    add: '添加',
    clone: '复制',
    completed: '课程已完成'
  },

  course: {
    upcoming_course: '即将发布的课程',
    unPublishEvent: '取消发布的活动',
    unPublishAssessment: '取消发布的评估',
    pastCourse: '培训课程',
    upcoming: '即将到来的直播活动',
    pastEvent: '过去的直播活动',
    pastAssessment: '过去的直播评估',
    upcomingAssessment: '即将到来的直播评估',
    created: '创建日期:',
    assignees: '受让人',
    organisations: ' {{ 组织 }} 组织, <2> {{ 用户 }} 用户</2>',
    event_date: '实时事件日期 <1> {{ 日期 }} </1>',
    delete_warning: '是否确认要删除这个',
    clonning_no_lesson: '为复制这个课程，请至少添加一节课。',
    clone_warning: '是否确定复制这个',
    clone_success: '正在复制',
    disclaimer: `我保证我的课程不会:
    -侵犯任何第三方的权利
    -包含任何违法行为，包括诽谤、淫秽、不雅、淫秽、色情、暴力、辱骂、侮辱、威胁或歧视性内容，甚至用星号伪装
    - 包含对他人的人身攻击
    - 包含任何模仿其他参与者、公众人物或名人的行为
    - 未经任何个人同意，包含任何个人的任何记录或个人信息，且不违反世界任何地区的任何数据保护法规
    - 包含任何商业招标或任何形式的“垃圾邮件”'`
  },

  coursecreate: {
    dropzone_text: '插入多媒体',
    sidebar_text: '选择一个主题 <1/> 给你的 <3/> 课',
    delete_warning: '确定要删除此课吗？'
  },

  coursepage: {
    quizview_loading: '正在检查答案，请稍后...',
    quizview_answer: '你的答案'
  },

  coursequiz: {
    title: '全部课的测验'
  },

  dashboard: {
    tooltip_title: '不再显示该视频',
    page_title: '你的课程’ 统计',
    page_subtitle: '您创建的课程的状态',
    profile_add_info: '添加你的 <1>{{未完成文本}}</1> 以完成您的个人资料.',
    profile_build:
      '建立您的个人资料 <1>在这里</1>, 让我们了解您的个人兴趣和技能。',
    profile_title: '个人资料完成度',
    more_details: '更多详情'
  },

  errors: {
    answer: '请输入答案',
    answer_correct: '选择正确答案',
    code: '请输入您的代码',
    criterion: '请输入条件',
    duration: '时长为必填项',
    element: '输入元素',
    email: '请输入您的电子邮件',
    email_invalid: '输入的电子邮件无效',
    feedback_correct: '请输入正确的反馈',
    feedback_incorrect: '请输入不正确的反馈',
    host: '请输入直播主机',
    host_assessment: '请输入评估主机',
    image: '请上传图片',
    location: '请输入您的位置',
    live_location: '请选择播放位置',
    limit: '请输入直播分钟',
    min_3char: '最少3个字符',
    number: '请输入正数。',
    host_email_require: `需要主机的电子邮件。`,
    attendee_email_require: `需要参与者的电子邮件`,
    name: '请输入你的名字',
    not_found_course: '未找到课程',
    not_found_event: '未找到活动',
    not_found_assessment: '未找到评估',
    password: '请输入您的密码',
    password_digit: '至少一位',
    password_short: '密码太短，至少十个字符',
    password_special: '至少一个特殊字符',
    password_uppercase: '至少一个大写字符',
    password_lowercase: '至少一个小写字符',
    phone: '请输入您的电话号码',
    phone_invalid: '电话号码无效',
    position: '请输入您的职位',
    question: '请输入您的问题',
    start_date: '需要输入开始日期和时间',
    tag: '请选择一个标签',
    topics: '请选择至少一个主题',
    live_topics: '请添加主题',
    title: '请输入标题',
    title_assessment: '请输入评估标题',
    title_course: '请输入课程标题',
    title_empty: '标题不能为空',
    title_event: '请输入活动标题',
    title_lesson: '请输入本课标题',
    title_quiz: '请输入测试名称',
    username: '请输入您的用户名',
    upload_error: '错误 – 文件不兼容!',
    upload_more_than_10: '一次最多只能上传10个文件。',
    topics_max: '请最多添加三个主题。',
    upload_excel: '请确保您已上传正确的文件。',
    title_excel: '上传模板时错误:',
    file_size_exceed: '超过文件大小',
    subtitle_excel: '请确保使用提供的模板，并且填写正确。',
    select_broadcast_option: '请选择一个选项来播放此直播',
    multi_hosts_number_error: '演示者的数目不能超过直播活动指定的数目。',
    conference_people_number_error: ` 参与者人数不能超过直播活动的指定人数`,
    select_max_host: '为事件选择至少1个演示者',
    select_max_conference: '为事件选择至少1名参与者。',
    stream_stop_error: '数据流意外停止!',
    unsecure_context:
      '致命错误：浏览器无法访问摄像头和麦克风，因为内容不安全。请安装SSL并通过https访问',
    ws_not_supported: '致命错误：此浏览器不支持WebSocket',
    no_org: '选择至少一个组织以继续。',
    no_org_group: '选择至少一个组织中的群组以继续操作。',
    waiting_to_join: '等待某人加入！'
  },

  events: {
    title: '添加实时事件详细信息',
    change_host: '更改主机',
    finished: '活动以完成',
    countdown: '直播将会播放。 ',
    subtitle: '给你的活动命名，告诉你的观众他们应该从中得到什么。',
    poll_disabled: '此活动中不提供投票',
    disclaimer: `我保证我记录的活动不会:
     -侵犯任何第三方的权利
    -包含任何违法行为，包括诽谤、淫秽、不雅、淫秽、色情、暴力、辱骂、侮辱、威胁或歧视性内容，甚至用星号伪装
    - 包含对他人的人身攻击
    - 包含任何模仿其他参与者、公众人物或名人的行为
    - 未经任何个人同意，包含任何个人的任何记录或个人信息，且不违反世界任何地区的任何数据保护法规
    - 包含任何商业招标或任何形式的“垃圾邮件”'`,
    prompt_message: '离开此页面将结束您的活动。您确定要离开此页面吗?',
    duration_exceed_message: '您的播放时间超时，应用程序将停止播放。',
    before_schedule_message:
      '您将在计划的活动时间之前开始播放。请注意，停止播放将结束活动。',
    browser_unsupportive_message:
      '您的浏览器不支持屏幕共享。您可以在这个链接中看到支持的浏览器',
    cancel_switch_host_message: '主机不可用。这项活动将从你这边继续进行。',
    coaching_prompt_message: '在活动完成之前，您不能离开此页。',
    event_modal_warn: '是否要退出此活动?',
    confirm_message: '如果单击“确定”，您的活动将结束。',
    screen_share_denied: '您拒绝共享您的屏幕',
    media_not_found: '在您的设备中找不到或不允许使用摄像头或麦克风',
    media_not_access: '摄像头或麦克风正被其他不允许读取设备的进程使用',
    constraint_error:
      '没有找到符合您的视频和音频限制的设备。您可以更改视频和音频限制',
    media_access_denied: '您不允许访问摄像机和麦克风。'
  },

  filters: {
    days7: '过去7天',
    days15: '过去15天',
    days30: '过去30',
    days365: '最后365天',
    date: '创建日期',
    relevance: '关联',
    popularity: '人气',
    name: '名称',
    group: '组',
    Newest_to_Oldest: '最新到最老',
    Oldest_to_Newest: '最老到最新',
    A_Z: 'A到Z',
    Z_A: 'Z到A'
  },

  helpers: {
    password:
      '为了确保您帐户的安全，我们要求您的密码中至少有一个小写字母，数字。您的密码至少需要10个字符',
    phone: '请输入您的电话国家代码，例如：+65',
    username:
      '您的用户名将被视为公共信息，并根据需要与其他用户共享。因此，我们建议您不要在用户名中使用个人信息',
    public_description_normal:
      '您的 <0><0/></0> 已保存，默认情况下被视为私有。这意味着只有您可以看到此内容。要发布此内容，您可以选择以下选项之一。向公众发布你的课程意味着它将对平台中的所有用户开放。“特定用户”选项将使您能够与Sharelook帐户关联的电子邮件地址与特定用户共享您的课程。',
    public_description_admin:
      '此 <0><0/></0> 已保存，默认情况下被视为私有。这意味着只有您（和内容创建者）才能看到此内容。要发布此内容，您可以选择以下选项之一。将您的课程发布到公共平台意味着平台中的所有用户都可以使用该课程，包括组织外部的用户。将其发布到组织意味着组织内的所有用户都可以看到它。您还可以将其发布到一个或多个组，这意味着只有这些组中的用户才能看到它。最后，您可以选择使用Sharelook帐户电子邮件地址将其发布给组织内外的特定用户。'
  },

  labels: {
    add: '添加',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: '答案类型',
    answers: '答案',
    back_to_quiz: '返回测试列表',
    back_to_question: '返回问题列表',
    chat: '聊天',
    chat_available: '此活动不提供聊天功能',
    chat_report: '聊天报告',
    choice_single: '单选',
    choice_multiple: '多选',
    choice_free: '"自由" 选择',
    choice_sorting: '"排序" 选择',
    choice_matrix: '"矩阵排序" 选择',
    clone_lesson_permission: '复制权限',
    code: '代码',
    correct: '正确',
    created: '创建日期',
    clone_modal: '复制课程',
    cloning_course: '正在复制课程...',
    cloning: '复制中...',
    cloning_course_desc: '此过程需要一点时间，请耐心等待',
    cloning_success: '课程 "<0/>" 已经复制成功!',
    description: '说明',
    disclaimer: '免责声明',
    drop_file: '在此删除文件...',
    duration: '时长',
    edit: '编辑',
    email: '电子邮件',
    event: '活动',
    event_all: '他的所有活动',
    event_date: '直播活动的当地日期/时间',
    event_this: '此活动',
    expire: '到期',
    expiry_date: '到期日期',
    forgot: '忘记密码?',
    group: '组',
    groups_list: '组列表',
    host: '主机',
    id_annotation: '注释id',
    id_quiz: '测试id',
    incorrect: '不正确',
    interests: '兴趣',
    invited: '邀请',
    live_chat: '直播讨论',
    live_stream_limit: '直播分钟数',
    contact_text: '若要更改每月直播限制，请联系',
    contact_admin:
      '<0>如果您希望更改每月直播限制，请联系</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      '直播剩余分钟: <0>{{ limit }}</0> 分钟 <1/><2/> <3>若要更改您的每月直播限制，请联系</3> <4>admin@sharelook.com</4>',
    location: '位置',
    lessons: '课程',
    location_broadcast: '主机服务器位置',
    location_broadcast_subtitle: '添加最接近广播主机位置的位置以减少视听延迟',
    media_manager: '媒体管理器',
    minutes: '分钟',
    name: '名称',
    online_quiz: '在线测试',
    organiser: '作者',
    organization: '组织',
    overall_emotion: '整体体验:',
    organizations_list: '组织列表',
    password: '密码',
    participants: '参与者',
    picture: '图片 (16:9)',
    phone: '电话',
    photo: '照片',
    poll: '投票',
    position: '职位',
    processing: '正在处理',
    privacy_settings: '隐私设置',
    question: '问题',
    quiz_create: '创建新测验',
    quiz_name: '测验名称',
    quiz_update: '更新测验',
    select_organization: '选择组织',
    settings: '设置',
    show: '显示',
    show_graph: '显示图表结果',
    signin: '登录',
    signup: '注册',
    sort_by: '排序依据',
    start_date: '开始日期',
    tags: '标签',
    terms: '我同意这些 <1>条款和条件</1>.',
    title: '标题',
    topics: '主题',
    topic: '主题',
    total_comments: '总评论',
    username: '用户名称',
    users_list: '用户列表',
    users_emails: '插入特定用户电子邮件',
    description_specifiction_email:
      '请每行输入一个电子邮件地址，以便与多个特定用户共享此邮件。',
    message_specific_email: '请输入特定用户的电子邮件。',
    viewers: '观众',
    edit_course: '编辑课程',
    edit_assessment: '编辑评估',
    edit_event: '编辑活动',
    delete_course: '删除课程',
    delete_event: '删除活动',
    delete_assessment: '删除评估',
    view_course: '查看课程',
    view_event: '查看活动',
    view_assessment: '查看评估',
    date_event: '直播活动日期',
    date_assessment: '直播评估日期',
    clone_of: '复制',
    clone_course:
      '创建复制此课程，您可以独立于原课程进行修改，包括所有课和页面。',
    make: '生成',
    available_to: '可供任何 ShareLook 用户使用',
    uploaded_by: '上传人: ',
    course: '课程',
    assessment: '评估',
    user_not_exist: '用户不存在，是否发送邀请?',
    check_user: '通知',
    user_not_exist_in_org: '用户不在这个组织中，是否发送邀请?',
    title_modal_stream: '改变组织中直播的限制',
    des_warning_stream: '您将要更改',
    monthly_stream: '每月直播限制:',
    min_per_month: '分钟/月',
    broadcast_label: '我想要做:',
    hosts_emails: `插入特定主持人的电子邮件`,
    attendee_emails: `插入特定参与者的电子邮件`,
    description_host_specifiction_email: '请每行输入一个电子邮件。',
    presenter_label: '演示者',
    presenter_label_conference: '人的编号',
    event_privacy: '会议模式'
  },

  broadcastOptions: {
    stream_from_phone: '用我的手机进行直播',
    other_webrtc: '来自我的电脑的网络会议',
    multihost: '来自我的电脑的群播网络会议',
    peer2peer: '培训课程',
    conference: '直播会议'
  },

  lessoncreate: {
    title: '添加课程详情',
    subtitle: '给你的课命名，并且告诉你的观众他们应该从中得到什么。',
    input_label_title: '课的标题',
    input_label_topics: '课的主题',
    input_label_description: '课程说明',
    delete_warning: '确定要删除此页吗?'
  },

  lessonoverview: {
    title: '添加课',
    subtitle: '添加现有的一课，还是创建新的一课',
    new_lesson: '创建新一课',
    new_lesson_sub: '从头开始创建全新的一课!',
    existing_lesson: '选择现有的一课',
    existing_lesson_sub:
      '链接到现有的课，对此课所做的更改也将影响其他课程中的此课',
    clone_lesson: '复制现有的课',
    clone_lesson_sub:
      '在本课程中制作此课的唯一副本，对此课所做的更改不会影响原始的课。',
    clone_lesson_modal_sub: '请单击要添加到课程中的课下面的“复制”按钮。'
  },

  management: {
    groups_title: '管理组',
    delete_warning: '你确定吗?',
    organizations_title: '我的组织',
    organizations_subtitle: '将组织添加到你的列表',
    users_title: '管理用户',
    users_position: '高级用户管理者',
    user_not_found: '没有找到该用户',
    select_org: '请查找并选择要管理用户的组织'
  },

  audio: {
    modal_title: '插入音频',
    list_view: '列表视图',
    create_audio_modal_title: '创建音频',
    edit_audio_modal_title: '编辑音频',
    public_audio_not_found: '没有找到该音频。',
    private_audio_not_found: '您尚未上传任何音频',
    are_you_sure_to_delete: '您确定要删除吗?',
    type_something: '说些什么',
    select_voice: '选择',
    file_name: '文件名',
    description: '说明',
    topic: '主题',
    key_words_tag: '关键词标签',
    mp3_audio: 'MP3 音频',
    created: '已创建',
    duration: '时长',
    close: '关闭'
  },

  image: {
    modal_title: '插入图片',
    image: '图片',
    pixel: '像素',
    dimension: '尺寸',
    public_image_not_found: '未找到该图片',
    private_image_not_found: '您尚未上传任何图像'
  },

  annotation: {
    modal_title: '注释'
  },

  text: {
    modal_title: '文本编辑'
  },

  video: {
    modal_title: '插入视频',
    image: '视频',
    mp4_video: 'MP4 视频',
    public_video_not_found: '未找到该视频',
    private_video_not_found: '您尚未上传任何视频'
  },

  media: {
    title: '媒体库',
    subtitle: '你的文件库',
    modal_title: '上传媒体',
    delete_warning: '确认删除',
    delete_message: '已删除的媒体仍将出现在使用它们的页面上',
    dropzone_text: '或拖放',
    delete_success: '媒体已被成功删除',
    upload_file: '上传文件',
    drag_drop: '或拖放',
    import_file: '从您的电脑导入文件',
    no_media: '您尚未上传任何媒体',
    media_type: '媒体类型',
    video: '视频',
    image: '图片',
    audio: '音频',
    gif: 'GIF动态图片',
    transcribed_text: 'Transcribed Text',
    media_not_found: '未找到该媒体',
    of: '属于',
    disclaimer: `我保证我的媒体不会:
    -侵犯任何第三方的权利
    -包含任何违法行为，包括诽谤、淫秽、不雅、淫秽、色情、暴力、辱骂、侮辱、威胁或歧视性内容，甚至用星号伪装
    - 包含对他人的人身攻击
    - 包含任何模仿其他参与者、公众人物或名人的行为
    - 未经任何个人同意，包含任何个人的任何记录或个人信息，且不违反世界任何地区的任何数据保护法规
    - 包含任何商业招标或任何形式的“垃圾邮件”'`,
    my_media: '我的媒体',
    public_library: '公共库',
    organization_library: '组织库',
    upload_from_computer: '从电脑上传',
    create: '创建',
    all: '全部',
    male: '男',
    female: '女',
    processing_audio: '正在处理音频',
    create_annotation: '创建注释',
    popup_over_lesson_text: '点击后在课程页面上弹出注释',
    edit_detail: '编辑细节',
    delete: '删除',
    go_create_audio: '去创建音频',
    show_more_details: '显示更多详情',
    show_less_details: '显示较少详情',
    drop_files: '删除文件和上传位置',
    or: '或',
    import_files: '从计算机导入文件'
  },

  navigation: {
    account: '账户',
    assessments: '评估',
    dashboard: '控制面板',
    groups: '群组管理',
    logout: '注销',
    organisations: '组织',
    organizations_users: '组织 & 用户',
    reports: '报告',
    schedule: '计划',
    training: '训练',
    nowLive: '广播',
    users: '用户',
    workshop: '我的工作室'
  },

  onboarding: {
    step1_title: '第 1 步: 告诉我们一些关于你自己的事',
    step1_subtitle: '你叫什么名字? 你从哪里来? 你的?',
    step2_title: '第 2 步: 选择一些你想要提升的技能',
    step2_subtitle:
      '接下来，告诉我们你想更好地理解什么。也许是你还没学会的东西？一个新的学习领域？你喜欢做什么?'
  },

  pagebuilder: {
    title: '创建一节课',
    subtitle:
      '是时候为你的观众创造内容，让他们向你学习，你可以添加图片、视频和信息图表',
    select_layout: '选择页面布局',
    template1: '空白',
    template2: '标题 & 副标题',
    template3: '标题 & 文本',
    template4: '标题, 媒体 & 文本',
    template5: '标题 & 媒体',
    template6: '标题 & 测验'
  },

  pageconstructor: {
    title: '创建和复制课',
    subtitle:
      '是时候为你的观众创造内容，让他们来向你学习了，你可以添加图片、视频和信息图表'
  },

  passwordreset: {
    success_coded:
      '我们已通过电子邮件将验证码发送到您提供的地址，请将验证码复制到下面的地方以设置新密码。',
    success_changed: '您已成功设置新密码，您现在可以登录了。'
  },

  placeholders: {
    search: '搜索',
    answer: '答案',
    chat: '说点什么...',
    code: '代码',
    criterion: '标准',
    date_event: '选择日期 & 时间',
    date_start: '开始日期',
    date_expire: '截止日期',
    description: '说明',
    elements: '排序要素',
    email: '电子邮件',
    feedback_correct: '反馈正确',
    feedback_incorrect: '反馈不正确',
    host: '主机',
    keywords: '搜索关键词',
    lesson_description: '本课说明',
    location: '位置',
    minutes: '分钟',
    name: '名称',
    organiser: '作者',
    organization: '组织',
    password: '密码',
    phone: '电话',
    photo: '照片',
    picture: '图片',
    point: '点',
    position: '职位',
    question: '问题',
    quiz: '测验名称',
    search_course: '按课程搜索',
    search_media: '按媒体搜索',
    search_name: '按名称搜索',
    search_title: '按标题搜索',
    search_training: '搜索练习',
    settings: '设置',
    tags: '标签',
    title: '标题',
    topics: '主题',
    username: '用户名',
    keyword: '关键词',
    max_500_characters: '最多500字',
    no_description: '此文件没有说明',
    no_keyword: '此文件没有关键词',
    no_topics: '此文件没有设置主题',
    feedback: '消息',
    contact: '我们能提供什么帮助?'
  },

  publishsettings: {
    title: '发布设置',
    event_subtitle: '向您的活动添加设置，谁可以查看您的活动并与之互动',
    assessment_subtitile: '给你的评估命名，告诉你的听众他们应该从中学到什么',
    course_subtitle: '向您的课程添加设置，谁可以查看您的课程并与之互动',
    disclaimer: `1. 注册注册为用户/创建帐户即表示您同意我们的[用户协议]并确认阅读了我们的[隐私政策]
    2. 创建课程
    通过使用我们的工具和创建课程内容，您同意我们的[用户协议]并确认阅读我们的[隐私政策]3.创建活动
使用我们的工具并创建活动，即表示您同意我们的[用户协议]并确认阅读了我们的[隐私政策]
4. 创建评估
使用我们的工具并创建评估，即表示您同意我们的[用户协议]并确认阅读了我们的[隐私政策]
dates_validation_error: '两个日期都应填写。',
  emails_validation_error: '电子邮件列表无效。',
  specific_email_validation_error: '只允许一个电子邮件。',
  i_agree_to_these: '我同意这些 ',
  terms_and_conditions: '条款和条件。',
  PublicDescription:
'免费独立用户: (隐私和公共选项)你的 [课程|活动|评估] 已保存，默认情况下被视为私有。这意味着只有您可以看到此内容。若要发布此内容，您可以选择在下面将其公开。这意味着该课程将面向平台中的所有用户。',
  OrganisationsDescription:
'组织用户: (使用“发布” 而不是“完成”，将到发布页面，与其他用户相同，但没有任何发布选项。)你的 [课程|活动|评估] 已经保存，并且为私有。这意味着只有您和组织中的管理员才能看到它。作为用户，您不能自己在组织内发布内容，因为这需要管理员权限。请与您的管理员联系，要求他们将您的内容公开发布到整个组织、组织内的特定组或特定用户。',
  OrganisationGroupsDescription:
'组织管理员: (对于组织内制作的内容：私有、公共、组织、组、特定用户):这个 [课程|活动|评估]已保存，默认情况下被视为私有。这意味着只有您（和内容创建者）才能看到此内容。要发布此内容，您可以选择以下选项之一。将您的课程发布到公共平台意味着平台中的所有用户都可以使用该课程，包括组织外部的用户。将其发布到组织意味着组织内的所有用户都可以看到它。您还可以将其发布到一个或多个组，这意味着只有这些组中的用户才能看到它。最后，您可以选择使用Sharelook帐户电子邮件地址将其发布给组织内外的特定用户。',
  SpecificUsersDescription:
'付费独立用户: (私人、公共和特定用户)你的 [课程|活动|评估] 已保存，默认情况下被视为私有。这意味着只有您可以看到此内容。要发布此内容，您可以选择以下选项之一。向公众发布你的课程意味着它将对平台中的所有用户开放。“特定用户”选项将使您能够通过Sharelook帐户关联的电子邮件地址与特定用户共享您的课程。'`
  },

  quiz: {
    quiz_empty: '您尚未创建测验',
    questions_empty: '您尚未创建问题'
  },

  regions: {
    asia_pacific_australia: '澳大利亚',
    asia_pacific_india: '印度',
    asia_pacific_japan: '日本',
    asia_pacific_s_korea: '韩国',
    asia_pacific_singapore: '新加坡',
    asia_pacific_taiwan: '台湾',
    eu_belgium: '比利时',
    eu_germany: '德国',
    eu_ireland: '爱尔兰',
    south_america_brazil: '巴西',
    us_central_iowa: '爱荷华州',
    us_east_s_carolina: '南卡罗莱纳	',
    us_east_virginia: '弗吉尼亚洲',
    us_west_california: '加利福尼亚',
    us_west_oregon: '俄勒冈州'
  },

  reports: {
    title: '报告',
    workshop_report: '工坊报告',
    user_report: '用户报告',
    organization_workshop: '组织的工坊',
    course: '课程',
    live_event: '直播活动',
    workShop_graph: '工坊图表',
    organization_account: '组织账号',
    all: '全部',
    name: '名称',
    id_number: '账号',
    email: '电子邮箱',
    search_user_report: '搜索用户报告',
    participant: '参与者',
    participants: '参与者',
    host: '主机',
    username: '用户名',
    event: '活动',
    quiz: '测验',
    assessment: '评估',
    time: '时间',
    no_recent_activity: '没有最近活动',
    workshops: '工坊',
    courses: '课程',
    live_events: '直播活动',
    live_assessments: '在线评估',
    quizzes: '测验',
    overview: '概述',
    by: '通过',
    views: '视图',
    status: '状态',
    poll: '投票',
    comment: '评论',
    comments: '评论',
    no_comments: '没有评论',
    no_polls: '没有投票',
    live_date: '实时日期',
    score: '分数',
    question: '问题',
    submit: '提交',
    recent_activity: '最近的活动',
    ago: '前',
    no_data_found: '未找到数据',
    start_end_live: '开始/结束直播',
    join_leave_date: '加入/离开',
    watched_time: '观看时间',
    complete: '完成',
    in_complete: '完成',
    today: '今天',
    seven_days: '7七天',
    last_month: '上个月',
    one_year: '1年',
    all_time: '所有时间',
    report: '报告',
    from_date: '起始日期',
    to_date: '结束日期',
    all_workshop: '所有工坊',
    all_participants: '所有参与者',
    live_assessment: '在线评估',
    users: '用户',
    download: '下载',
    recent: '最近',
    WorkShop: '工坊',
    Activity: '活动',
    created_date: '创建日期',
    lessons: '课',
    lesson: '课',
    completed: '已完成',
    report_download: '下载报告',
    this_month: '这个月',
    search_course: '搜索课程',
    participants_graph: '参与者图表',
    viewed: '已查看',
    enrolled: '已注册',
    description: '说明',
    topic: '话题',
    analytic: '分析',
    quiz_list: '测验列表',
    select_one: '选择一个',
    group_status: '群组状态',
    duration_min: '持续时间(分钟)',
    submit_poll: '提交投票',
    download_events: '下载活动',
    search_event: '搜索活动',
    duration: '时长',
    total_participants: '所有参与者',
    message: '消息',
    avg_message: '平均消息',
    per_message: '消息/活动的百分比'
  },

  signup: {
    success_step1:
      '我们已经通过电子邮件将验证码发送到您提供的地址，请将该验证码复制到下面的字段以确认您的注册。',
    success_step2: '谢谢。您已成功注册。',
    privacy: `我同意Sharelook的 <1>条款 & 条件</1> 和 <3> 隐私政策</3>`
  },

  stream: {
    emotion_impressive: '令人赞叹',
    emotion_unimpressive: '平庸的',
    message_not_started: '即将到来',
    message_running: '运行中',
    message_processing:
      '我们目前正在处理直播录音以便回放。请稍后回来查看视频并继续添加评分和反馈'
  },

  tabs: {
    audience: '观众',
    course: '课程概述',
    details: '直播详情',
    description: '说明',
    host: '主机',
    lesson: '课的概述',
    lessons: '课',
    overview: '概述',
    page: '页面生成器',
    publish: '发布',
    settings: '发布设置',
    total_views: '总浏览量',
    live_participates: '直播参与者',
    live_chats: '直播聊天',
    live_quiz: '直播投票',
    trainer_rating: '培训师等级',
    trainer_times: '培训师时间',
    courses_quizzes: '课程测验',
    user_list: '用户列表',
    discussion: '讨论',
    notes: '我的笔记'
  },

  topics: {
    SALES_TRAINING: '销售培训',
    NEGOTIATION_TRAINING: '谈判培训',
    CROSS_CULTURAL_AWARENESS: '跨文化意识',
    NETWORKING_SKILLS: '网络技能',
    SOFTWARE_ARCHITECTURE: '软件构架',
    PROJECT_MANAGEMENT: '项目管理',
    DIGITAL_TRANSFORMATION: '数字转换',
    IT_CONSULTING: 'IT 咨询',
    MANAGEMENT_CONSULTING: '管理咨询',
    HR_CONSULTING: '人力资源咨询',
    INTERNET_OF_THINGS: '物联网 (IoT)',
    CYBERSECURITY: '网络安全',
    PRIVACY_AND_GDRP: '隐私和GDPR'
  },

  training: {
    title: '培训',
    title_assessment: '评估',
    subtitle: '课程和直播活动',
    enrolled_title: '登记课程和直播活动',
    enrolled_subtitle: '您登记的课程和直播活动',
    enrolled_message: '您目前没有参加任何课程和活动。',
    past_live_event_title: '过去的直播活动',
    past_live_event_subTitle: '已完成的直播活动',
    past_live_event: '当前没有过去的直播活动',
    recomended_title: '推荐的课程和直播活动',
    now_live_event_title: '正在直播的',
    now_live_event_subTitle: '正在直播或将快开始的活动',
    now_live_event: '当前没有直播活动。',
    webinar_event_title: '网络研讨会频道',
    webinar_event_subTitle: '已完成的网络研讨会',
    webinar_event: '当前没有网络研讨会',
    p2p_event_title: '培训课程 ',
    p2p_event_subTitle: '已完成的培训课程',
    p2p_event: '当前没有培训课程。',

    now_live_assessment_title: '新的直播',
    now_live_assessment_subTitle: '正在直播评估或即将到来的评估',
    now_live_assessment_message: '当前没有直播评估',

    upcoming_assessment_title: '即将到来的直播评估',
    upcoming_assessment_subtitle: '即将到来的直播评估',
    upcoming_assessment_message: '目前还没有即将到来的直播评估',

    past_live_assessment_title: '过去的直播评估',
    past_live_assessment_subTitle: '已完成的直播评估',
    past_live_assessment_message: '目前没有直播评估',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle: '我们根据您的<0><0/></0>策划课程和直播活动',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: '搜索培训',
    search_assessment: '搜索评估',
    recomended_message: '目前没有推荐的课程和直播活动。'
  },

  warnings: {
    delete: '你确定吗?'
  },

  workshop: {
    title: '我的工作室',
    subtitle: '创建课程或主持你自己的直播活动。',
    new_course: '创建一个新课程',
    new_event: '创建一个新的直播活动。',
    new_assessment: '创建一个新的直播评估',
    courses_title: '创建课程 & 直播活动',
    courses_subtitle: '编辑 & 发布你的课程和计划的直播活动',
    tags_course: '课程',
    tags_live: '直播活动',
    tags_assessment: '直播评估'
  },

  help_center: {
    sidebar: {
      title: '我们能为您提供什么帮助?',
      back_to: '控制面板'
    },
    menu: {
      help_center: '帮助中心',
      whats_new: '新功能',
      feedback: '反馈',
      feedback_title: '向sharelook发送反馈',
      terms_and_conditions: '条款 & 条件',
      privacy_policy: '隐私政策',
      contact_us: '联系我们'
    },
    get_started: {
      title: '由ShareLook开始',
      description: {
        main: '我们已经将直播视频集成到了一个易于使用的课程生成器',
        tagline:
          '有了ShareLook的专利直播系统，你可以创建预约，自动化学习，最大限度地分享知识'
      }
    },
    whats_new: {
      title: '由 ShareLook开始',
      description: {
        main:
          '你知道吗，创造讲故事式的学习可以在短时间内创造出来，而且不会那么昂贵吗？你应该把ShareLook课程生成器和各自的才能结合起来。你可以问我们“怎么做”',
        tagline: ''
      }
    },
    create_workshop: '如何创建工作室',
    create_course: '如何创建课程',
    create_user: '如何创建用户',
    create_group: '如何创建组',
    create_webinar: '如何创建网络研讨会',
    create_live_event: '如何创建直播活动',
    create_live_assessment: '如何创建直播评估',
    create_live_on_mobile: '在移动设备上创建直播',
    personalize_profile: '个性化配置文件',
    manage_group: '管理组',
    report: '报告',
    add_annotations: '如何添加批注/弹出窗口',
    add_audio: '如何添加音频',
    add_header_and_footer: '添加页眉 & 页脚',
    add_image: '如何添加图片',
    add_quiz_content: '如何添加测试内容',
    add_text_content: '如何添加文本内容',
    add_user: '如何添加用户',
    add_video: '如何添加视频',
    clone_course: '如何复制课程',
    find_live_broadcast: '如何查找课程直播',
    contact_us: {
      title: '联系我们',
      subject_placeholder: '输入主题*',
      content_placeholder: '输入消息*',
      subject_required: '*主题是必填的',
      content_required: '*内容是必填的',
      submit: '发送',
      cancel: '取消',
      sent: '已发送'
    },
    feedback: {
      title: '向 sharelook发送反馈',
      attach_title: '附加文件',
      choose: '选择文件',
      detail: '文件将与团队共享',
      content_placeholder: '输入消息*',
      content_required: '*内容是必填的',
      submit: '发送',
      cancel: '取消',
      sent: '已发送'
    }
  },
  discussion: {
    join_discussion: '加入讨论'
  },
  notes: {
    title: '我的笔记',
    add_note: '添加新笔记'
  }
}
